webpackJsonp([1],{

/***/ "3jmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mjxm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a4f08ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("xJNA")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-0a4f08ab"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b17162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("Mjxm")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67fad68a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("lsaJ")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b08f99d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("fbGF")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1538bbbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("OLkq")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutubeOrOlympics: function isYoutubeOrOlympics() {
      return this.videoURL.search('youtube') !== -1 || this.videoURL.search('olympic') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c81c71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutubeOrOlympics)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("3jmS")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a5686a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("l+EB")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Revue Olympique - Numéro 126",
  "shortTitle": "",
  "description": "",
  "width": 719,
  "height": 890,
  "currentLanguage": "FR",
  "languages": [{
    "code": "FR",
    "text": "French",
    "href": "http://revueolympique.touchlines.com/126"
  }, {
    "code": "EN",
    "text": "English",
    "href": "http://olympicreview.touchlines.com/126"
  }],
  "basePath": "/126",
  // "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "http://olympic-review.s3-website-eu-west-1.amazonaws.com/126/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 1-title-1\" style=\"top:14px;left:2px;\" src=\"/126/static/_content/1-title-1.png\"/>\n      <img class=\"abs halfScale 1-title-2\" style=\"top:11px;left:235px;\" src=\"/126/static/_content/1-title-2.png\"/>\n      <img class=\"abs halfScale 1-header\" style=\"top:132px;left:223px;\" src=\"/126/static/_content/1-header-1.png\"/>\n      <img class=\"abs halfScale 1-date\" style=\"top:132px;left:585px;\" src=\"/126/static/_content/1-date-issue-1.png\"/>\n      \n      <img class=\"abs halfScale 1-subtitle\" style=\"top:244px;left:34px;\" src=\"/126/static/_content/1-subtitle-1.png\"/>\n      <img class=\"abs halfScale 1-subtitle\" style=\"top:299px;left:33px;\" src=\"/126/static/_content/1-subtext-1.png\"/>\n      <img class=\"abs halfScale 1-caption\" style=\"top:366px;left:566px;\" src=\"/126/static/_content/1-text-1.png\"/>\n      <img class=\"abs halfScale 1-caption\" style=\"top:437px;left:566px;\" src=\"/126/static/_content/1-text-2.png\"/>\n      <img class=\"abs halfScale 1-caption\" style=\"top:507px;left:566px;\" src=\"/126/static/_content/1-text-3.png\"/>\n      <img class=\"abs halfScale 1-logo\" style=\"top:831px;left:15px;\" src=\"/126/static/_content/1-logo-1.png\"/>\n      <img class=\"abs halfScale 1-link\" style=\"top:863px;left:633px;\" src=\"/126/static/_content/1-link-1.png\"/>\n\n      <div class=\"contentLink\" style=\"top:859px;left:627px;width:80px;height:18px\">\n        <a href=\"https://www.olympics.com/fr/\" target=\"_blank\"></a>\n      </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-title-1\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"1-title-2\"), 0.6, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"1-header\"), 0.6, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n          .fromTo(cOf(\"1-date\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.5)\n          .staggerFromTo(cOf(\"1-subtitle\"), 0.7, {opacity:0, x:40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1.7)\n          .staggerFromTo(cOf(\"1-caption\"), 0.6, {opacity:0, x:-40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.9);\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "REVUE Publication officielle du Mouvement olympique  TM  Juin 2026 Numéro 126  Dakar 2026 Premier événement sportif olympique organisé sur le sol africain, les Jeux Olympiques de la Jeunesse de Dakar 2026 inspireront toute une génération et créeront des opportunités pérennes grâce au sport  Plongée au cœur du patrimoine culturel et historique qui attend les visiteurs au Sénégal Les athlètes modèles se livrent sur la manière dont ils encadreront les participants aux JOJ Deux photographes sénégalais capturent l’énergie de la scène sportive dakaroise  olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 4-title\" style=\"top:114px;left:44px;\" src=\"/126/static/_content/4-title-1.png\"/>\n      <img class=\"abs halfScale 4-sub\" style=\"top:178px;left:43px;\" src=\"/126/static/_content/4-sub-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(6);\" style=\"top:363px; left:50px; width:116px; height:90px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(16);\" style=\"top:302px; left:218px; width:140px; height:129px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(8);\" style=\"top:538px; left:90px; width:158px; height:127px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(30);\" style=\"top:745px; left:294px; width:262px; height:111px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(cOf(\"4-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"4-sub\"), 0.9, {opacity:0, y:20}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "4  Sommaire  SOMMAiRE  PUBLICATION OFFICIELLE DU MOUVEMENT OLYMPIQUE JUIN 2026  16  DAKAR 2026 EN BREF  6  AVANT-PROPOS  À l’approche de Dakar 2026, décryptage du programme des sports, des sites de compétition et de l’impact pérenne de l’événement.  Par la présidente du CIO, Kirsty Coventry.  8  INTERVIEW DE LA PRÉSIDENTE DU CIO  Kirsty Coventry explique pourquoi les prochains Jeux Olympiques de la Jeunesse sont l’occasion idéale de valoriser la culture et l’esprit de l’Afrique.  30  DAKAR 2026 LEARNING ACADEMY  Un programme de formation qui promet non seulement d’aider à la livraison de Dakar 2026, mais aussi de révéler les futurs professionnels du secteur sportif."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(38);\" style=\"top:155px; left:182px;; width:129px; height:125px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(48);\" style=\"top:307px; left:54px; width:235px; height:105px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(62);\" style=\"top:245px; left:352px; width:149px; height:116px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(64);\" style=\"top:587px; left:326px; width:175px; height:123px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(78);\" style=\"top:744px; left:51px; width:115px; height:113px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(80);\" style=\"top:744px; left:202px; width:137px; height:113px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(82);\" style=\"top:744px; left:366px; width:85px; height:113px;\"></div>\n\n      <div class=\"addContentLink\" style=\"top:564px;left:530px;width:119px;height:10px\">\n        <a href=\"https://www.olympics.com/cio\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:573px;left:530px;width:111px;height:8px\">\n        <a href=\"mailto:olympicreview@olympic.org\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Revue Olympique  5  Numéro 126  COMMISSION EXÉCUTIVE  38  Présidente Kirsty Coventry Vice-présidents Nawal El Moutawakel, Gerardo Werthein, Baron Pierre-Olivier Beckers-Vieujant, Juan Antonio Samaranch Membres SAR le Prince Feisal Al Hussein, Mikaela Cojuangco Jaworski, Lingwei Li, Spyros Capralos, Kristin Kloster, Octavian Morariu, Ingmar De Vos, Pau Gasol Sáez, Neven Ilic, Jae Youl Kim  UNE VITRINE CULTURELLE  Célia Cuordifede présente le patrimoine culturel et historique qui attend celles et ceux qui se rendront au Sénégal pour les JOJ.  REVUE OLYMPIQUE  62  AU-DELÀ DES ANNEAUX  48  Rémy Rioux explique comment le sport peut être un moteur pour l’éducation, la paix et le développement à long terme.  À TRAVERS L’OBJECTIF  Un retour en images sur l’énergie de la scène sportive dakaroise, mêlée à la vie quotidienne, capturé par les photographes sénégalais Sidy Talla et Badara Preira.  Directeur de la communication institutionnelle et des affaires publiques Christian Klaue Rédactrice en chef Katharine Mann Corédactrice en chef et édition française Lucile Tonnerre Édition espagnole Dolores Blázquez Agence de production Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Conor Ketley Design Liz Rankin, Shyama Rajani, Apostolis Tatasopoulos, Jen Thich Retouche d’image Liz Rankin Secrétariat de rédaction Quentin Huon Traduction Aurélien Sagnier, Indira Akanni Relecture Nathalie Herrmann, Michèle Salvat ISSN : 0251-3498 Imprimée au Royaume-Uni  IMAGES Couverture : Sidy Talla Intérieur : CIO ; CIO/Greg Martin ; CIO/Quinton Meyer ; CIO/Ubald Rutar ; CIO/Muhammed Camara ; CIO/Badara Preira ; CIO/Nelson Chavez ; CIO/Giulio Locatelli ; CIO/Richard Juilliart ; CIO/Benoît Fontaine ; CIO/Roberto González Espeso ; commission de coordination des Jeux Olympiques de la Jeunesse d’été de Dakar 2026 ; Olympics.com ; Getty Images ; Sidy Talla ; Rémy Rioux ; Salah-Eddine Gakou ; Steve Lorcy ; Penny Bird ; Blessing Oborududu ; Jamila Lunkuse  CONTACTS  64  La Revue Olympique est imprimée sur du papier certifié PEFC fabriqué à partir de bois de forêts gérées dans le souci du développement durable.  LES ATHLÈTES MODÈLES  Des athlètes de haut niveau venus de tous les horizons sportifs vont encadrer les jeunes participants à Dakar 2026, perpétuant la tradition des JOJ.  78  80  82  Les parutions recensées par le Centre d’Études Olympiques du CIO.  Les olympiens et les personnalités du Mouvement olympique qui nous ont quittés.  Les faits et chiffres des JOJ de Dakar 2026.  ÉTUDES OLYMPIQUES  DÉCÈS  LE MOT DE LA FIN  La Revue Olympique est publiée par le Comité International Olympique. Les articles publiés dans la Revue Olympique ne reflètent pas nécessairement les opinions du CIO. Toute reproduction sans l’accord du département de la communication institutionnelle et des affaires publiques du CIO est interdite. La terminologie olympique (en particulier OlympiquesTM et Jeux OlympiquesTM) et les autres propriétés olympiques sont des marques déposées (TM) appartenant au CIO. Pour de plus amples informations sur la protection des propriétés olympiques, veuillez consulter le site : olympics.com.  Toutes les informations sont correctes au moment de l’impression.  Écrivez-nous à : Revue Olympique, Département de la communication institutionnelle et des affaires publiques, Maison Olympique, 1007 Lausanne, Suisse Site internet : www.olympics.com/CIO E-mail : olympicreview@olympic.org Tél. : +41 (0)21 621 6111"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 7-title\" style=\"top:97px;left:43px;\" src=\"/126/static/_content/7-title-1.png\"/>\n      <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top:762px; left:474px; height:69px; width:100px; background-color:#ffffff\"></div>\n\n      <div class=\"addContentLink\" style=\"top:338px;left:273px;width:53px;height:13px;\">\n        <a href=\"https://www.olympics.com/fr/olympic-games/dakar-2026\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.fromTo(cOf(\"7-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(idOf(\"7-sig\"), 0.9, {width:155,x:0}, {width: 0,x:167, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop();         \n          removeContentLinks();\n        }\n      ",
    "searchText": "Revue Olympique  7  Numéro 126  AVANT-PROPOS DE KiRSTY COVENTRY D  Dakar offrira un cadre exceptionnel pour les 4es Jeux Olympiques de la Jeunesse d’été.  ans quelques mois, le Mouvement olympique arrivera à Dakar pour y vivre un moment historique : la première compétition sportive olympique de l’histoire organisée sur le sol africain. En tant qu’Africaine et olympienne, je suis profondément ﬁère et enthousiaste. Dakar 2026 sera une célébration du sport, de la jeunesse et des possibilités. Placés sous la devise « L’Afrique accueille, Dakar célèbre », ces Jeux Olympiques de la Jeunesse (JOJ) montreront au monde entier l’énergie, la créativité et l’ambition d’une nouvelle génération. Si ces JOJ sont à part, ce n’est pas seulement en raison du sport, mais aussi de ce qu’il rend possible. Cet événement offre aux jeunes athlètes l’occasion de participer à des compétitions, de grandir et de vivre les valeurs olympiques à un moment charnière de leur vie. Pour beaucoup, il s’agira de leur  première expérience du Mouvement olympique. Ils noueront des amitiés par-delà les cultures, découvriront de nouvelles opportunités et en tireront des leçons qui les suivront bien après la ﬁn des JOJ. Cet esprit se ressent déjà partout au Sénégal. Dakar 2026 allie sport, éducation et culture en demeurant ﬁdèle au pays et au continent. De la musique à l’art, en passant par la célébration des communautés et les programmes à destination des jeunes, cette édition est façonnée avec ﬁerté par l’identité sénégalaise et la créativité de sa jeunesse. Le programme sportif en lui-même est un reﬂet de cette approche. Aux côtés des sports en compétition, les jeunes athlètes et les visiteurs auront aussi la possibilité de découvrir des sports d’engagement qui attirent de nouveaux publics et stimulent la participation, la découverte et le plaisir. Dakar 2026 crée déjà des opportunités au-delà de l’aire de compétition. À travers des initiatives comme la Learning Academy, de jeunes professionnels originaires du Sénégal et de toute l’Afrique gagnent de l’expérience dans l’organisation d’événements sportifs majeurs. Les programmes de formation basés sur les valeurs olympiques atteignent aussi des centaines de milliers de jeunes, les aident à renforcer leur conﬁance, leurs compétences en leadership, ainsi que leur sens de la communauté. C’est là le véritable héritage des Jeux Olympiques de la Jeunesse de Dakar 2026. Au ﬁl des pages suivantes, vous découvrirez certains des acteurs et des projets qui donnent vie à ce rendez-vous : des athlètes qui inspirent la nouvelle génération, de jeunes leaders qui contribuent à façonner l’avenir, ainsi que des artistes et des photographes qui capturent l’esprit de Dakar. J’espère que ces récits vous laisseront la même sensation qu’à moi : de l’enthousiasme quant à ce qui nous attend et de la conﬁance dans ce que cet événement peut apporter à la jeunesse non seulement en Afrique, mais aussi aux quatre coins du monde. ■  Kirsty Coventry, présidente du CIO"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 8-quote-box\" style=\"top:144px;left:61px;\" src=\"/126/static/_content/8-quote-box-1.png\"/>\n      <img class=\"abs halfScaleC 8-quote-text\" style=\"top:78px;left:-103px;\" src=\"/126/static/_content/8-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 8-quote-icon\" style=\"top:74px;left:51px;\" src=\"/126/static/_content/8-quote-icon-1.png\"/>\n      <img class=\"abs halfScaleC 8-sub\" style=\"top:597px;left:-27px;\" src=\"/126/static/_content/8-sub-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.fromTo(cOf(\"8-quote-box\"), 0.9, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"8-quote-icon\"), 0.9, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.3)\n          .fromTo(cOf(\"8-quote-text\"), 0.9, {opacity:0, x: 25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.5)\n          .fromTo(cOf(\"8-sub\"), 0.9, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6);\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n        }\n      ",
    "searchText": "8  Interview de la présidente du CIO  «  Une expérience inoubliable pour les jeunes athlètes LA PR…SIDENTE DU CIO KIRSTY COVENTRY ESTIME QUE LES JEUX OLYMPIQUES DE LA JEUNESSE DE DAKAR 2026 SONT LíOCCASION ID…ALE DE VALORISER LA CULTURE ET LíESPRIT DE LíAFRIQUE ET DE BRISER LES ST…R…OTYPES. PAR STEVE WILSON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"abs halfScale 9-quote-box\" style=\"top:144px;left:-658px;\" src=\"/126/static/_content/9-quote-box-1.png\"/>\n      <img class=\"abs halfScaleC 9-quote-icon\" style=\"top:504px;left:499px;\" src=\"/126/static/_content/9-quote-icon-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim.fromTo(cOf(\"9-quote-box\"), 0.9, {opacity:0, y: -30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"9-quote-icon\"), 0.9, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n        }\n      ",
    "searchText": "Revue Olympique  9  Numéro 126  » Kirsty Coventry a présidé la commission de coordination de Dakar 2026 jusqu’à son élection à la présidence du CIO."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "10  Interview de la présidente du CIO  1  K  irsty Coventry sait déjà qu’elle versera une larme. Lorsque viendra le 31 octobre 2026, personne ne ressentira plus de ﬁerté et d’émotion que la présidente du Comité International Olympique (CIO) à l’occasion de la cérémonie d’ouverture des Jeux Olympiques de la Jeunesse (JOJ) de Dakar 2026, le premier événement olympique de l’histoire à se tenir en Afrique. « Je ne vais pas tenir en place, conﬁe Kirsty Coventry, et j’espère ne pas trop pleurer. » Pour la présidente du CIO, ces JOJ offrent au Sénégal et à l’Afrique la chance de briser des stéréotypes et de mettre en valeur tout ce que le continent à de plus beau à offrir. Et elle parle d’expérience. Kirsty Coventry a grandi à Harare au Zimbabwe, s’entraînant dans des piscines extérieures non chauffées en hiver pour devenir l’olympienne ornée du plus beau palmarès d’Afrique. En tant que membre du CIO, elle a dirigé la commission de coordination (CoCom)  de Dakar 2026, de 2018 à l’an dernier, où elle est devenue la première femme et la première personne issue du continent africain à être élue à la présidence du CIO.  Surpasser les attentes « Je pense que l’Afrique est souvent sousestimée, déclare-t-elle. J’ai vraiment hâte que les gens viennent à Dakar et soient surpris de ne pas être déçus. Je suis impatiente qu’ils arrivent et disent : “Ouah, je ne m’attendais pas à ça. C’est bien mieux que ce que j’imaginais !” « Ces stéréotypes systématiques sont encore bien présents. J’aimerais en briser certains. Mais surtout, j’ai envie que chacun découvre véritablement la culture et l’esprit de l’Afrique. » Au cours des huit années qui se sont écoulées depuis que les Jeux Olympiques de la Jeunesse ont été attribués à Dakar, Kirsty Coventry a assisté à une transformation en profondeur de la capitale sénégalaise, aﬁn  d’accueillir dans les meilleures conditions les jeunes athlètes pour la quatrième édition estivale des JOJ. « Vous voyez les sites se construire, presque brique par brique, explique-t-elle. Et d’un coup, ils franchissent un cap et vous vous dites : “Bon sang, c’est magniﬁque !” Soudain, vous voyez à quoi ils vont réellement ressembler. » De l’aveu même de la présidente, sa propre équipe a été étonnée en arrivant à Dakar pour les réunions de la CoCom, admettant d’une seule voix être agréablement surprise. La même réaction a été observée chez tous ceux qui ont assisté au festival Dakar en Jeux, qui propose des activités sportives et culturelles et qui est organisé chaque année en préparation des JOJ. « Ils se sont demandé : “Comment avez-vous mobilisé tous ces gens et tous ces jeunes ?”, glisse Kirsty Coventry. Je leur ai répondu : “C’est l’Afrique. C’est notre façon de faire. C’est de cette manière qu’on vit nos célébrations.” »"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  11  Numéro 126  2  2  Un parcours personnel La préparation jusqu’en 2026 s’est déroulée en parallèle de l’ascension de Kirsty Coventry jusqu’au sommet du Mouvement olympique. En 2018, lorsque Dakar s’est vue attribuer l’organisation des JOJ lors de la 133e Session du CIO à Buenos Aires – pendant les précédents Jeux Olympiques de la Jeunesse – elle était à la fois présidente de la commission des athlètes et ministre des Sports du Zimbabwe. Lors de cette même Session, elle a aussi été nommée présidente de la CoCom de Dakar 2026. Initialement prévus en 2022, les JOJ ont été reportés à 2026 en raison de la COVID-19. Après son élection historique à la présidence du CIO en mars 2025, Kirsty Coventry a passé le relais de la présidence de la CoCom à Humphrey Kayange, membre kényan du CIO. Elle a également suivi les changements à la tête du Sénégal. Bassirou Diomaye Faye a été élu président du pays en 2024, succédant à Macky Sall pour devenir le plus jeune  dirigeant élu d’Afrique, à 44 ans. « Il est intéressant de voir l’accent que le gouvernement met sur le sport ainsi que l’importance qu’il lui accorde pour aider les jeunes à grandir et à offrir aux gens des opportunités de progresser et de développer de nouvelles compétences. » Kirsty Coventry a pu voir de près ces nouvelles dynamiques, lorsqu’elle s’est rendue à Dakar l’an dernier pour diriger sa dernière réunion de la CoCom en tant que présidente. « J’ai senti un changement dans l’air, explique-t-elle. Les opportunités que ces Jeux Olympiques de la Jeunesse peuvent apporter au Sénégal, mais aussi à l’Afrique en général, semblent mieux comprises aujourd’hui qu’auparavant. C’est formidable que le sport soit reconnu pour le rôle qu’il peut jouer. »  Des JOJ pour un continent Dakar 2026 est présenté comme un événement non seulement pour le Sénégal, mais plus globalement pour l’ensemble de l’Afrique. Mais ces JOJ peuvent-ils réellement représenter un  1 Le volleyball de plage fera partie des 25 sports au programme des Jeux de Dakar 2026. 2 Le festival annuel Dakar en Jeux a suscité un vif enthousiasme en amont des JOJ.  continent aussi vaste et aux coutumes si diverses ? Kirsty Coventry en est persuadée. Ayant grandi dans un pays anglophone d’Afrique australe, elle estime que ces JOJ – organisés dans une nation francophone d’Afrique de l’Ouest – peuvent unir tout le continent. Elle cite régulièrement la philosophie africaine de l’ubuntu qui signiﬁe : « Je suis parce que nous sommes. » « Il existe au sein du peuple sénégalais toute une série de traditions qui se retrouvent aussi au Zimbabwe, souligne-t-elle. Alors oui, il y a des différences, mais elles font partie d’une même famille. Lorsque les visiteurs se rendront au Sénégal, ils auront un aperçu de la diversité de l’Afrique, de la richesse de sa culture et de son patrimoine. Je pense que cela permettra de représenter pleinement le continent. » Les JOJ seront évidemment avant tout une compétition sportive, à laquelle participeront environ 2 700 athlètes âgés de 14 à 17 ans, souvent pour une première expérience internationale. En tant qu’olympienne originaire d’Afrique, Kirsty Coventry connaît bien les déﬁs auxquels sont confrontés les jeunes athlètes africains pour espérer se révéler à Dakar."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 12-quote\" style=\"top:471px;left:-49px;\" src=\"/126/static/_content/12-quote-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.fromTo(cOf(\"12-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n        }\n      ",
    "searchText": "12  Interview de la présidente du CIO  1  1  « Vous verrez tout cela à Dakar : des athlètes déterminés qui veulent faire leurs preuves et montrer tout leur talent. » KIRSTY COVENTRY, PRÉSIDENTE DU CIO  Ayant grandi à Harare, c’est en regardant les Jeux de Barcelone 1992 à la télévision qu’elle a eu envie de devenir une athlète olympique. Après avoir pratiqué plusieurs sports dans sa jeunesse, elle a jeté son dévolu sur la natation et a lancé sa propre carrière olympique. « L’hiver, nous nagions dans une piscine extérieure non chauffée : en grandissant au Zimbabwe, c’était notre réalité, et nous n’avions pas conscience qu’ailleurs, les choses se faisaient différemment. L’objectif était de nager aussi longtemps que possible, avant d’aller courir ou jouer au hockey : c’était notre plan B pour rester en forme. »  Kirsty Coventry a reçu une bourse pour étudier à l’université d’Auburn (USA), où elle gagne plusieurs titres nationaux en natation. Elle a ensuite disputé cinq éditions des Jeux Olympiques, remportant sept médailles dont deux en or – un palmarès inégalé en Afrique. « C’est seulement en arrivant aux États-Unis que je me suis dit : “Mais attends, tout le monde ne s’entraîne pas comme nous, dans une piscine délabrée ?”, raconte-t-elle. Et je pense qu’à Dakar, nous verrons l’incroyable talent que possède l’Afrique et qui doit être soutenu pour réaliser tout son potentiel. »  L’héritage des athlètes Forte de sa propre expérience, Kirsty Coventry sait que les athlètes africains seront motivés pour faire leurs preuves sur la scène mondiale. « Nous sommes des athlètes avides de succès – eux aujourd’hui comme moi hier, estime-t-elle. Nous voulons bien faire. Nous voulons progresser. Notre objectif est de tout donner à la moindre opportunité qui nous est offerte. »  « Je pense que vous verrez tout cela à Dakar : des athlètes déterminés qui veulent faire leurs preuves et montrer tout leur talent. Et quand ils en auront l’occasion, ils la saisiront des deux mains et iront jusqu’au bout. » Elle a bon espoir de voir certains de ces athlètes africains exceller lors des Jeux Olympiques à l’avenir – à LA28 ou, plus probablement, à Brisbane 2032. « Si les athlètes de Dakar atteignent des ﬁnales ou décrochent des médailles dans six ans à Brisbane, alors je pense que nous pourrons évaluer l’impact et le succès de cet héritage », souligne-t-elle. La présidente du CIO espère également que les jeunes athlètes issus de régions du monde plus aisées comprendront et mesureront mieux les difficultés que leurs homologues africains doivent surmonter, à commencer par le manque d’infrastructures et de ﬁnancements. « J’espère qu’ils se diront : “On bénéﬁcie d’infrastructures magniﬁques chez nous, alors que ces athlètes vivent une réalité très différente – et pourtant, regardez ce qu’ils arrivent à faire ! Ne prenons rien pour acquis. Mettons les choses en perspective.” « Pour moi, si les athlètes du monde entier repartent d’Afrique en étant plus ouverts aux expériences nouvelles et différentes, alors je considérerai que là aussi, ce sera un succès. Je pense qu’ils ne s’attendent pas à un tel niveau de compétition, ni à découvrir ces superbes sites en Afrique. J’espère qu’ils mesureront la richesse de cette expérience et ce qui a été mis en valeur. »  Le chemin à parcourir Les JOJ en Afrique ont relancé la perspective d’organiser des Jeux Olympiques pour la première fois sur le continent. L’Afrique du Sud fait partie des nombreux pays à avoir exprimé leur intérêt pour accueillir les Jeux en 2036 ou 2040. Kirsty Coventry préfère ménager les attentes, sans faire de vaines promesses. « Différentes régions du monde n’ont encore jamais accueilli les Jeux Olympiques et pourraient en bénéﬁcier grandement. Je suis impatiente d’étudier comment nous pouvons  1 Avec sept médailles, Kirsty Coventry est l’athlète olympique la plus médaillée d’Afrique. 2 La coureuse de steeple kenyane Fancy Cherono en action aux JOJ de Buenos Aires en 2018."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  13  Issue 119  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 14-quote\" style=\"top:497px;left:-45px;\" src=\"/126/static/_content/14-quote-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(cOf(\"14-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n        }\n      ",
    "searchText": "14  Interview de la présidente du CIO  1 1  « Dakar sera magnifique. Ce sera une expérience inoubliable pour tous ces jeunes athlètes. » KIRSTY COVENTRY, PRÉSIDENTE DU CIO  y remédier et ouvrir les Jeux à de nouvelles régions pour que cela devienne une réalité. » La présidente du CIO précise qu’il n’existe pour l’heure aucun calendrier pour l’organisation potentielle de Jeux Olympiques en Afrique, tout en soulignant que les conditions doivent être réunies et le timing correct. « Cela doit être fait de manière consciente et authentique, estime-t-elle. Il ne s’agit pas de forcer les choses, car cela n’apporterait qu’instabilité et manque de durabilité. Personne n’a envie de se retrouver avec des éléphants blancs… »  « Si nous encourageons de nouveaux pays ou de nouvelles régions, cela doit être aligné avec leur développement et leurs objectifs à long terme aﬁn d’être réellement un succès. Il faut que ce soit fait de manière à ce que l’héritage ne soit pas négatif. » Dakar 2026 intervient à une période où le CIO travaille sur l’avenir des Jeux Olympiques de la Jeunesse dans le cadre de l’agenda « Fit for the Future ». Des changements ont déjà été apportés au programme sportif et à d’autres aspects des Jeux de Dakar, mais des transformations plus profondes pourraient voir le jour pour les éditions futures des JOJ. « Nous devons réellement analyser la situation si nous souhaitons que les JOJ se poursuivent, explique la présidente. De quoi s’agit-il exactement ? Quel est leur impact et l’objectif ? S’agit-il de hautes performances, de formation ? Pour le moment, tout est un peu mélangé et cela ne correspond pas forcément aux attentes de chacun.  « Dakar sera magniﬁque. Ce sera une expérience inoubliable pour tous ces jeunes athlètes. Je pense qu’ils en ressortiront très inspirés par les valeurs olympiques. Mais pour l’avenir, nous devons réévaluer ce que sont les JOJ et ce qu’ils devraient être. » D’ici là, une chose est certaine : à l’approche de la cérémonie d’ouverture de Dakar 2026, la présidente sait déjà combien ce moment sera chargé d’émotion sur le plan personnel. « Je serai très émue. Il y aura certainement des mouchoirs à portée de main ! » ■  1 L’Afrique du Sud a accueilli la Coupe du monde de football 2010."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "omegawatches.com  CHRONOMÉTREUR OFFICIEL Le compte à rebours est lancé avant les Jeux Olympiques de la Jeunesse de Dakar 2026. Premier événement sportif du CIO organisé sur le continent africain, cette compétition marquera aussi les débuts de nombreuses carrières sportives prometteuses. En tant que &KURQRP«WUHXU2IƸFLHOGHFHWWH«GLWLRQKLVWRULTXH20(*$SRXUVXLW son héritage olympique, riche de 94 années d’expérience, d’expertise et d’innovations techniques. La référence absolue en matière de précision, au service de milliers de jeunes athlètes qui incarnent la prochaine génération de l’excellence."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 16-title\" style=\"top:104px;left:42px;\" src=\"/126/static/_content/16-title-1.png\"/>\n      <img class=\"abs halfScale 16-title\" style=\"top:250px;left:44px;\" src=\"/126/static/_content/16-title-2.png\"/>\n      <img class=\"abs halfScale 16-sub\" style=\"top:402px;left:43px;\" src=\"/126/static/_content/16-sub-1.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.staggerFromTo(cOf(\"16-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1)\n          .fromTo(cOf(\"16-sub\"), 0.9, {opacity:0, y:35}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n        }\n      ",
    "searchText": "16  Feature: Dakar 2026 Overview  UNE PAGE D’HiSTOiRE PREMIER …V…NEMENT OLYMPIQUE ORGANIS… EN AFRIQUE, LES JEUX OLYMPIQUES DE LA JEUNESSE DE DAKAR 2026 SERVIRONT DE SOURCE DíINSPIRATION POUR TOUTE UNE G…N…RATION ET CR…ERONT DES OPPORTUNIT…S P…RENNES GR¬CE AU SPORT, ESP»RENT LES ORGANISATEURS. PAR MICHAEL STONEMAN  La lutte de plage fera ses débuts olympiques aux JOJ de Dakar 2026."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "18  Dakar 2026 en bref  L  es usagers qui empruntent la gare de Colobane à Dakar passent devant une fresque difficile à manquer. Haute de sept mètres et longeant une passerelle très fréquentée, elle offre un rappel coloré de l’arrivée imminente des Jeux Olympiques de la Jeunesse (JOJ) et des jeunes qu’ils visent à inspirer. Créée par deux artistes urbaines de talent, Zeinixx et Kathrina Rupit, cette peinture murale qui réunit trois générations d’athlètes sénégalaises accroche l’œil. Les deux premières sont immédiatement reconnaissables par les passants : Julie Marie Gomis est une pionnière, un modèle pour le pays depuis 1976, lorsqu’elle est devenue la première Sénégalaise à disputer les Jeux Olympiques. Elle est accompagnée de Combé Seck, la spécialiste du canoë sprint et porte-drapeau lors de la cérémonie d’ouverture de Paris 2024. Au sommet de cette fresque monumentale trône Tening Faye, l’adolescente qui incarne la nouvelle génération du sport sénégalais. Un futur qui connaîtra un véritable tournant lors des JOJ de Dakar 2026. Par cet événement, le Sénégal deviendra la première nation africaine à organiser un événement olympique. En 2025, à l’âge de 15 ans, Tening Faye est devenue la première Sénégalaise à remporter une médaille aux Championnats du monde 1 cadets de taekwondo, en s’emparant du bronze dans la catégorie -44 kg pour sa première participation à une compétition de ce calibre. « C’était fort en émotions, conﬁe-t-elle. C’était ma toute première compétition internationale et j’ai remporté la médaille de bronze. J’en suis très ﬁère. » Deux ans plus tôt, Tening Faye n’avait jamais pratiqué de taekwondo. C’est une amie qui lui a donné l’envie de s’y essayer. « [Mon amie] passait devant chez moi pour se rendre aux entraînements et, à chaque fois, j’avais envie de me joindre à elle, explique la championne. Alors ma mère a parlé à l’entraîneur et c’est comme ça que ma carrière a commencé. C’était très difficile au début, parce que je ne maîtrisais pas les coups de pied. Mais l’entraîneur a quand même réussi à me faire progresser. »  1 Tening Faye est entrée dans l’histoire du Sénégal lors des Championnats du monde cadets de taekwondo. 2 Le programme du Brevet olympique, civique et sportif vise à toucher 900 000 enfants. 3 Les participants se dépensent sans compter lors du festival annuel Dakar en Jeux.  1  La progression fulgurante de la jeune athlète lui a permis de monter sur le podium des Championnats du monde cadets. Elle espère reproduire l’exploit dans son propre pays à l’occasion des JOJ. Son ambition reﬂète l’enthousiasme grandissant qui règne au Sénégal et dans toute l’Afrique, à l’approche de ce moment historique.  « Une déclaration de foi » « Lorsque le Comité International Olympique a désigné le Sénégal en 2018, il a placé sa conﬁance non seulement dans un pays, mais dans tout un continent », déclare Ibrahima Wade, coordinateur général du comité d’organisation de Dakar 2026 (COJOJ). « Notre devise, “L’Afrique accueille, Dakar célèbre”, reﬂète cette responsabilité collective : ce ne sont pas uniquement les JOJ de Dakar, mais un tournant pour l’ensemble de l’Afrique. »  2  Cette étape historique verra concourir près de 2 700 athlètes issus de tous les Comités Nationaux Olympiques pendant les 14 jours de compétition. Les épreuves se répartiront entre Dakar, Diamniadio, une ville à l’essor rapide située à environ 30 kilomètres à l’est de la capitale sénégalaise, et Saly, une station balnéaire à 80 kilomètres au sud. « C’est réellement monumental », souligne Humphrey Kayange, membre du CIO et président de la commission de coordination du CIO pour Dakar 2026. « Accueillir les Jeux au nom d’un continent, c’est quelque chose. « Pour l’Afrique, l’accueil d’un tel événement sportif s’accompagne de grandes responsabilités. Cela façonnera non seulement son avenir, mais aussi celui de tous ceux qui viendront célébrer les Jeux sur un nouveau continent pour la première fois. Mais cela va bien au-delà de l’accueil des Jeux. C’est une déclaration de foi en une immense opportunité pour l’Afrique et en sa capacité à jouer un rôle moteur dans ce domaine. »  La jeunesse au cœur Plusieurs événements sportifs majeurs se sont déjà déroulés sur le continent, à commencer par la Coupe du monde de rugby en 1995 et la Coupe du monde de cricket en 2003. Un changement d’échelle s’est ensuite produit avec la Coupe du monde de la FIFA en 2010, qui a démontré la capacité de l’Afrique à accueillir un événement planétaire. D’autres"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 19-quote\" style=\"top:532px;left:283px;\" src=\"/126/static/_content/19-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 19-quote-img\" style=\"top:487px;left:195px;\" src=\"/126/static/_content/19-quote-img-1.png\"/>\n    \n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.fromTo(cOf(\"19-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"19-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop();\n        }\n      ",
    "searchText": "19  3  tournois comme les Jeux africains et la Coupe d’Afrique des Nations ont renforcé l’expérience sur l’ensemble du continent en termes d’organisation, d’infrastructures et de livraison. Dakar 2026 s’appuie sur ces fondations, tout en mettant l’accent sur l’utilisation du sport pour soutenir le développement sur le long terme. Environ 75 % de la population du Sénégal a moins de 35 ans : Dakar 2026 place donc les jeunes au cœur de son approche, en lançant de nombreux programmes en amont des JOJ, avec pour objectif d’améliorer l’accès au sport et de leur créer des opportunités. « Les jeunes ne sont pas seulement un public pour ces Jeux : ils sont au cœur de leur organisation », explique Ibrahima Wade. Dans le cadre de l’initiative « Jeunesse en Jeux », jusqu’à 300 000 jeunes vivront les Jeux Olympiques de la Jeunesse, comme spectateurs et comme participants à des activités sportives, culturelles et éducatives. Cette approche s’appuie sur des initiatives qui  « Cela façonnera l’avenir de l’Afrique et de tous ceux qui viendront célébrer les Jeux sur un nouveau continent pour la première fois. » HUMPHREY KAYANGE  ont déjà mobilisé plus de 480 000 jeunes à travers tout le pays. L’une des plus ambitieuses est le Brevet olympique, civique et sportif, un plan national d’éducation fondé sur les valeurs olympiques conçu pour mobiliser 900 000 élèves dans 11 000 écoles d’ici le début des JOJ en octobre. L’initiative « Kids’ Olympic Skills » offre aussi aux jeunes de 6 à 18 ans la possibilité de s’essayer à un large éventail de sports pour développer l’intérêt et la pratique au niveau amateur.  Dans le même temps, Dakar 2026 investit dans la formation de jeunes professionnels à travers la Learning Academy (voir page 30) qui forme des centaines de jeunes Sénégalais et Africains à la gestion du sport et d’événements. Un grand nombre d’entre eux devrait jouer un rôle dans la livraison des JOJ, créant un lien entre l’engagement de la jeunesse et l’organisation de l’événement lui-même. D’autres domaines sont explorés par ces initiatives : 15 aspirants journalistes ont été"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:144px;left:159px;width:81px;height:15px;\">  \n        <a href=\"https://www.olympics.com/cio/news/a-six-mois-des-joj-de-dakar-2026-les-jeunes-leaders-du-cio-s-appretent-a-incarner-les-valeurs-olympiques\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "20  Dakar 2026 en bref  sélectionnés pour le programme des jeunes reporters du CIO, avec notamment six jeunes originaires d’Afrique, dont trois du Sénégal. D’autre part, huit membres des jeunes leaders du CIO seront à Dakar pour mener des activités sportives à destination des jeunes athlètes et des communautés locales. Le programme des volontaires, dénommé « Jambaar26 », a également suscité un vif intérêt, avec plus de 14 000 candidatures reçues de 115 pays pour plus de 5 000 places. Ces chiffres soulignent l’enthousiasme à l’échelle locale et internationale.  1  1  « Les JOJ sont une invitation pour chaque jeune Sénégalais, indépendamment de son expérience sur un terrain ou dans une piscine, ajoute Ibrahima Wade. Grâce au programme à destination des écoles, aux bénévoles et à la Learning Academy, c’est toute une génération qui aura l’occasion de s’impliquer en tant qu’acteur plutôt que spectateur. »  De nouvelles générations, de nouveaux sports Ces initiatives – parmi d’autres – reﬂètent l’objectif plus large de Dakar 2026 d’utiliser les  JOJ comme un catalyseur pour le développement de la jeunesse, avec des programmes qui dépassent le cadre du sport, pour soutenir la formation et l’inclusion sociale au Sénégal et dans l’ensemble de la région. L’une de ses incarnations les plus visibles est Dakar en Jeux, un festival annuel lancé en 2022 qui mobilise les communautés locales, promeut un mode de vie sain et stimule l’enthousiasme jusqu’aux JOJ. Organisée dans les villes hôtes de Dakar 2026, cette initiative conjugue chaque année sport et culture à travers un programme d’activités qui inclut initiations sportives, démonstrations, concerts et performances artistiques. Des milliers de jeunes ont déjà participé à cet événement destiné à promouvoir l’activité physique, avec des ateliers dédiés à l’éducation, à la santé et au bien-être. Les festivals ont également été l’occasion de faire découvrir de nouveaux sports aux habitants de la région. Le BMX, le skateboard, le futsal et d’autres sports à roulettes ont été mis à l’honneur aux côtés de disciplines plus traditionnelles, offrant aux jeunes la chance d’essayer un grand éventail de sports, y compris ceux inscrits au programme de Dakar 2026.  La place centrale de la culture Le festival Dakar en Jeux a mis l’accent sur l’expression culturelle : musique, danse et art urbain ont joué un rôle central dans chaque édition. L’objectif est de reﬂéter l’identité du Sénégal, tout en créant un lien entre les Jeux et les communautés qui les accueilleront. Cette célébration de la culture sera également visible durant les Jeux, avec une place spéciale accordée au concept sénégalais de teranga, un mot wolof incarnant l’hospitalité, la générosité et l’esprit de communauté qui caractérisent la vie quotidienne dans le pays. Cet esprit marquera les JOJ pour les athlètes et les visiteurs, car les organisateurs cherchent à créer un environnement qui reﬂète l’ouverture d’esprit et la convivialité du Sénégal. « La teranga, tradition sénégalaise d’hospitalité et de générosité, n’est pas un simple concept de communication, précise Ibrahima Wade. C’est une réalité du quotidien et les Jeux ont été conçus pour que chaque visiteur la ressente dès son arrivée. »  1 Plus de 14 000 candidatures ont été reçues pour le programme de bénévolat « Jambaar26 »."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 22-quote\" style=\"top:695px;left:298px;\" src=\"/126/static/_content/22-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 22-quote-img\" style=\"top:651px;left:195px;\" src=\"/126/static/_content/22-quote-img-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.fromTo(cOf(\"22-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"22-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n        }\n      ",
    "searchText": "22  Feature: Dakar 2026 Overview  1  1  Pour les jeunes athlètes, ce concept sera visible au village olympique de la jeunesse, où ils rencontreront des artisans locaux, découvriront des jeux traditionnels et s’initieront aux danses et instruments de percussion d’Afrique de l’Ouest, comme le sabar et le djembé. Sur les sites de compétition, des performances culturelles accueilleront chaque délégation, tandis que le projet « Yeesal » – « renouveau » en wolof – transforme le paysage urbain de Dakar, Diamniadio et Saly en galerie à ciel ouvert, avec de grandes fresques dessinées par des artistes locaux et inspirées par les valeurs olympiques. L’une d’entre elles met à l’honneur Tening Faye, Combé Seck et Julie Marie Gomis à la gare de Colobane.  Un ancrage local L’accent mis sur l’identité locale et l’engagement de la jeunesse se reﬂète dans la conception  même de ces Jeux. Pour Dakar 2026, le CIO a adopté une nouvelle approche pour le programme des sports des JOJ, en adaptant davantage chaque édition en fonction de son pays ou de sa région hôte. Dakar 2026 sera la première édition à bénéﬁcier de ce modèle, avec un programme personnalisé, développé en collaboration étroite entre le COJOJ et les Fédérations Internationales (FI). Cette approche s’écarte d’un format ﬁxe, permettant à chaque édition des JOJ de reﬂéter les priorités et opportunités locales, tout en maintenant son rôle de compétition multisports de haut niveau.  Pour Dakar 2026, cela signiﬁe l’inclusion de 25 sports au programme de compétition, ainsi que dix sports intégrés dans un nouveau programme d’engagement. Si les sports de compétition suivront un format traditionnel, ceux d’engagement sont conçus pour offrir aux jeunes des communautés hôtes la possibilité de découvrir et d’essayer de nouvelles disciplines. « Nous savons que certains sports ne sont pas encore très connus en Afrique, explique Ibrahima Wade. Nous voulions donc offrir aux FI l’occasion de les présenter. » Ces sports d’engagement seront mis à l’honneur à travers des démonstrations, des  « C’est toute une génération qui aura l’occasion de s’impliquer dans ces JOJ, en tant qu’acteur plutôt que spectateur. » IBRAHIMA WADE  1 Un concert à Saly ﬁgurait parmi les nombreux événements du festival Dakar en Jeux."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 23-title\" style=\"top:99px;left:43px;\" src=\"/126/static/_content/23-title-1.png\"/>\n\n      <h1 id=\"23-no\" class=\"abs olympicHeadlineComp 23-no\" style=\"top:181px;left:496px; font-size: 1.9em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 2700, \"comma\" : true}' ></h1>\n\n      <div class=\"addContentLink\" style=\"top:98px;left:40px;width:478px;height:44px;\">  \n        <a href=\"https://www.olympics.com/fr/dakar-2026/joj-dakar-2026-programme-et-calendrier-de-competition/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim.staggerFromTo(cOf(\"23-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1)\n          .fromTo(cOf(\"23-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"23-no\")[0])}}, 1.2);\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n          removeContentLinks();\n          resetNumbers(\"23-no\");\n        }\n      ",
    "searchText": "Revue Olympique  23  Numéro 126  PROGRAMME DES SPORTS DE DAKAR 2026 25 SPORTS DE COMPÉTiTiON  QUi PARTiCiPE ? 2 700  athlètes (âge maximum : 17 ans)  Athlétisme  Aviron  Badminton  Baseball/Softball  Basketball  Boxe  Breaking  Cyclisme  Escrime  Football  Gymnastique  Handball  Judo  Lutte  Rugby  Skateboard  Sports aquatiques  Sports équestres  Taekwondo  Tennis de table  Tir à l’arc  Triathlon  10 SPORTS D’ENGAGEMENT  Voile  QUi PARTiCiPE ?  Canoë  Escalade sportive  Golf  Haltérophilie  Pentathlon moderne  Surf  Tennis  Tir  Volleyball  Wushu  Les jeunes, les communautés locales, les supporteurs présents sur place  Hockey  Karaté"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "24  Dakar 2026 en bref  Dakar 2026 vise à soutenir le développement d’un écosystème sportif plus large au Sénégal et dans l’ensemble de l’Afrique. « La pratique sportive est déjà très populaire en Afrique, poursuit Ibrahima Wade. Mais avec les Jeux Olympiques de la Jeunesse, nous pouvons soutenir la création d’une industrie du sport. C’est important. » Cela comprend des investissements dans les compétences, la formation et les infrastructures, ainsi qu’un renforcement des systèmes sportifs nationaux et la création de nouvelles opportunités pour les jeunes au-delà des JOJ. Des programmes comme la Dakar 2026 Learning Academy sont conçus pour offrir aux participants une expérience de terrain dans des domaines comme la gestion des événements, les opérations et l’administration, en aidant à former une main d’œuvre qui sera capable de participer à de futurs événements sportifs. Cette approche reﬂète aussi une ambition plus large de faire de Dakar un pôle régional dans le sport, à même d’accueillir des compétitions internationales et de soutenir le développement des athlètes sur le long terme. À travers des partenariats avec les FI et avec le soutien de la Solidarité Olympique, des initiatives sont mises en œuvre pour renforcer l’encadrement, le parcours des athlètes et la capacité organisationnelle de tout le continent. Associés aux programmes d’engagement de la jeunesse et à des investissements majeurs dans les infrastructures sportives, ces efforts  1  1  activités et des expériences de type festival, permettant aux jeunes de la région d’y prendre part directement, au lieu de se contenter de les regarder. L’objectif est de susciter l’intérêt et la participation à des sports encore peu présents au Sénégal ou dans la région. « Notre espoir en matière d’héritage est que les jeunes gens les découvrent et que ces sports continuent de grandir après les JOJ », souligne Ibrahima Wade. « C’est au cœur de notre approche, ajoute Humphrey Kayange. Adapter le programme sportif au contexte local garantit que les JOJ restent pertinents, tout en conservant leur rôle de tremplin vers le sport de haut niveau. »  Sous les cieux africains La philosophie derrière le programme des sports s’étend bien au-delà de la compétition :  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  25  Numéro 126  visent à garantir que l’impact de Dakar 2026 s’étendra bien au-delà de l’événement, créant des opportunités durables pour les jeunes du Sénégal et du reste de l’Afrique. « L’héritage matériel est tangible et durable, décrit Ibrahima Wade. Les JOJ laisseront derrière eux des infrastructures sportives transformées : un Complexe Iba Mar Diop réhabilité, une piscine olympique rénovée, un centre équestre de classe mondiale et 11/infrastructures sportives communautaires construites en partenariat avec les autorités locales dans tout le pays. » « Mais l’héritage intangible pourrait se révéler encore plus précieux. Les recherches sur l’impact à long terme des Jeux Olympiques indiquent systématiquement des effets qui dépassent les infrastructures : un renforcement pérenne de la culture du sport, un sentiment accru de cohésion nationale, ainsi que des avancées signiﬁcatives dans l’égalité des genres, tant dans l’accès au sport que dans la visibilité des femmes en tant qu’athlètes, leaders et modèles. » Selon lui, cet impact plus profond est toutefois plus difficile à mesurer. « C’est le moment où une jeune ﬁlle de Dakar voit une athlète de son continent monter sur un podium, où un garçon de Médina voit son quartier se transformer en site d’excellence internationale… Ce tremplin d’aspiration, c’est ce que le Mouvement olympique a toujours produit. Et c’est ce que Dakar 2026 est déterminé à laisser en héritage./» La majorité de cet impact est déjà en marche, à travers les programmes mis en place en amont de 2026, avec des initiatives axées sur la formation, le développement des compétences et l’accès au sport, pour créer des opportunités s’étendant bien au-delà de l’événement. « Nous allons planter ces graines d’héritage, clame Humphrey Kayange. Certains impacts se verront immédiatement, mais d’autres grandiront avec le temps. »  1 Le wushu fera son entrée dans le programme sportif des JOJ à Dakar 2026. 2 Le stade Abdoulaye Wade accueillera des épreuves dans la ville de Diamniadio. 3 Une foule nombreuse assiste à un concert lors du festival Dakar en Jeux. 4 Deux compétitions de basketball 3×3 seront organisées lors des JOJ.  Compte à rebours Mais avant que cet héritage ne se matérialise, l’attention est désormais focalisée sur les Jeux Olympiques de la Jeunesse en eux-mêmes, alors que l’enthousiasme monte au Sénégal et que de grands noms du sport et de la culture expriment leur impatience en cette ﬁn de compte à rebours en vue de Dakar 2026. Pour Kalidou Koulibaly, capitaine de l’équipe nationale de football du Sénégal et ambassadeur de Dakar 2026, les JOJ représentent un moment de ﬁerté pour tout le continent africain.  3  4"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 26-quote\" style=\"top:541px;left:293px;\" src=\"/126/static/_content/26-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 26-quote-img\" style=\"top:498px;left:196px;\" src=\"/126/static/_content/26-quote-img-1.png\"/>\n\n      <div class=\"contentLink\" style=\"top:578px;left:203px;width:18px;height:14px;\">  \n        <a href=\"https://www.olympics.com/fr/infos/kalidou-koulibaly-senegal-coupe-du-monde-olympique-dakar-2026-football\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:592px;left:43px;width:83px;height:14px;\">  \n        <a href=\"https://www.olympics.com/fr/infos/kalidou-koulibaly-senegal-coupe-du-monde-olympique-dakar-2026-football\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"contentLink\" style=\"top:673px;left:182px;width:56px;height:14px;\">  \n        <a href=\"https://www.olympics.com/fr/infos/qui-est-khaby-lame-nouvel-ambassadeur-dakar-2026-jeux-olympiques-jeunesse\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.fromTo(cOf(\"26-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"26-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "26  Dakar 2026 en bref  1  1  « C’est quelque chose qui ne s’est jamais produit auparavant », déclare la star des Lions de la Teranga. «/C’est historique car de grands événements ont eu lieu partout dans le monde, mais jamais en Afrique. C’est maintenant notre tour. Cet événement montrera au monde les talents et l’énergie qui existent partout en Afrique. » Autre ambassadeur des JOJ, Khaby Lame, la star de TikTok aux plus de 160 millions d’abonnés, souligne l’importance plus large de ces JOJ : « Dakar 2026 va donner à notre continent l’occasion de révéler le meilleur de lui-même et d’inspirer la jeunesse en Afrique et dans le monde entier. » « C’est pour nous une chance de démontrer qu’au-delà de sa résilience, l’Afrique est également une force. Je suis ﬁer d’être Sénégalais, ﬁer d’être Africain, et nous allons faire de ce premier événement olympique en Afrique un succès total. »  « Dakar 2026 va offrir à notre continent l’opportunité […] d’inspirer la jeunesse en Afrique et dans le monde entier. » KHABY LAME  À la gare de Colobane, les voyageurs continueront de passer chaque jour sous la fresque de Julie Marie Gomis, Combé Seck et Tening Faye alors qu’approche la cérémonie d’ouverture. En levant les yeux, ils croiseront le regard des deux grandes ﬁgures du sport sénégalais et d’une jeune athlète dont l’histoire débute tout juste, mais qui incarne déjà toute une génération à travers l’Afrique, prête à être inspirée par ce moment historique. ■  1 Khaby Lame, ambassadeur de Dakar 2026, en compagnie de la mascotte officielle, Ayo."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "28  Dakar 2026 en bref  L’AFRIQUE ACCUEILLE, DAKAR CÉLÈBRE  DiAMNiADiO 2 km  D  4  4 5  5  E  B  7 min  3  20 km  4. CENTRE ÉQUESTRE 17 min  2 2  Équitation (saut dʼobstacles)  Gare TER de Dakar 60 min  5. DAKAR ARENA  A  1  10 min  7. CENTRE DES EXPOSITIONS DE DAKAR 10 min  Badminton  1. COMPLEXE TOUR DE L’ŒUF 90 min  Natation 106 mins 106 10 6m ins Basketball 3×3  EXE TO 1. COMPLEXE PLEX OE PLEX OMPL COM COM TOUR UR DE DE LOEUF LL'OEUF OEUF UF Breaking  Tennis de table  6. STADE ABDOULAYE WADE  110 min  Cyclisme sur route  Karaté Tir  Ska Skateboarding teboar oarrd din ding ing (S Stre eet) et) et teb ((Street) 75kate min  Surf  min 87 87 mins in  HÔPITAL DEOP DAKAR OMPL 2. A. COMPLEXE CCOM OM PLEX EXEPRINCIPAL EX IBA MARR DIOP DI IBA MA PL 125 min  ns 5 mi 5 mins mins  6. STADE STA STADE DE ABDOULAYE ABDOU OULAYE LAYE YE W  Cérémonie dʼouverture  Centre International de chery Archery A Radio et Télévision Archer (CIRTV) Cyc ycling g Road Roa R d Cycling  ViLLAGE OLYMPiQUE E. CENTRE LOGISTIQUE DE LA JEUNESSE 26 mins PRINCIPAL 14 min Athlétisme (piste) CCEN RE EQUESTRE 4 CENTRE 4. EQUESTRE EQUEST STRE Basketball 3×3 Equestrian Eq estrian strrian (Ju Equest mp ng) Equ ue ng) ((Jumping) F.p CENTRE D’ACCRÉDITATION Baseball5 ET DES UNIFORMES  Escalade  Futsal  Gymnastique artistique Judo  Tir à l’arc  Tennis  seb Baseball5 Bas eballll5 IBA MAR DIOP Ba 2. COMPLEXE  Wushu (Taolu)  5 min  Sports d’engagement  Breaking re king king B reaki  Taekwondo  Boxe  3. CORNICHE OUEST  Haltérophilie  Athlétisme  Escrime  Futsal  Baseball5 Swimming mmi ming Swimmi Sw Skateboard (de rue) ×3 Ba 3 Bas ba 3×3 Basketball Basket ball ttba  Rugby à sept  Hockey Golf  Futsal  Pentathlon moderne  7 min  Rugby à sept  Canoë  ENGAGE SPORTS* ENGA ENGAGEMENT GAGEME GEMENT NT N SPORTS* S*  Locations o be e conﬁrmed conﬁrmed *Locations ations to *Lo  Taekwondo Triathlon (course à pied)  mins 19 mins 19 ns  G. CENTRE iNTERNATiONAL DE DAKDiOUF EXPO 7. DAKAR EEXP XPO XPO CENTR CE CONFÉRENCES ABDOU 10 min Fencing Fe Fenc ing Centre Principal de Presse (CPP) Taek Ta won ndo do Taekwondo kwo  Weightlifting We ghtlif Weig liftin ing  Spo Sport port port Climbing Clilimb bing ng  Cérémonie de clôture  Rug gby Sevens ev Ru Rugby S evens ens Sev  Te Tennis nnis  Hockey Ho Hoc cke key  At Athl etic ics Athletics ic et 125 min  Ka Kar Karate ate te  Golf Golf  ns 19 mins 19 mins D. THE GROUND H. HÔPITAL DES JOJ 14 min AR ARENA AREN A NA 19 min 5. DAKAR  Shooti Sho Shooting g  Pe Modern Mod Mod rn Penta Pentathlon ntathl t o  Surﬁ Surﬁng ﬁ g  Canoe Canoe  B. HÔPITAL MILITAIRE D’OUAKAM xing xing C.BBoxing SIÈGE DE DAKAR 2026 125sal min Futsal Fu Futsal  Centre Principal des Opérations (CPO) Centre des opérations techniques  H  F  1 1 35 km  6 6  Gare TER de Diamniadio  A1  DAKAR  C  7  7 G  Natation Boxe  Gymnastics Gymnas Gym nas s nastics  Ba Bad Badminton dminto to ton Gymnastique artistique Triathlon (natation)  Table nn ble Te nis Tennis Taolu) Wushu Wu Wushu hu (Ta (T (Taolu) Taol Art Artistic ist st stic ic Gymnastics Gyym mnastic tic cs Jud Judo Judo o"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  BEYOND THE RINGS  DAKAR 2026 : PLAN DIRECTEUR DES SITES Si S de compétition X X X Sites X X X S Sites hors compétition  Compétition Au  to r  out  A1 eA 1 Gare TER de l’aéroport  Entraînement Aéroport international Blaise Diagne  Sports d’engagement Village olympique de la jeunesse  35 min  35 min  Au  Aéroport international Blaise Diagne  to ro u te A1  WADE WADE WAD  RE  29  Numéro 126  Autoroute A1 Train Express Régional (TER) Gares TER Navette  20 km  Temps de trajet depuis le village olympique de la jeunesse  35 km  A1  LES SiTES OCÉAN ATLANTIQUE  56 m 56 mins in  8. PLAGE SALY OUEST PLAGEE OUEST 88. SALY PLAGE OUES UEST 55 min  8 8  SALY  ((Windsurﬁng) Winds Sailing Sa dsurﬁ urﬁ rﬁng) ng) g) g (Win  50 km  Rowing Coastal Beach h R stal Be Bea Planche à voile Sprint Sprints Sp intssplage Sprint de Beach ch de Volleyball Vollleyba eyballl en aviron mer Volleyball de nplagell Beach ch h Handball Handball plage Wre stling Beach chde Wr Wrestling stl ing ng est Lutte de plage Tri Triath athlon on Tr Triathlon Triathlon  O  Les Jeux Olympiques de la Jeunesse Dakar 2026 se dérouleront dans trois villes hôtes (Dakar, Diamniadio et Saly), avec des compétitions réparties sur huit sites au total — de la pittoresque plage de Saly, qui accueillera six sports dont le handball de plage et l’aviron de mer, à la Corniche Ouest, qui offrira un cadre spectaculaire pour les épreuves de cyclisme sur route. Véritable pôle central des festivités et de l’engagement des jeunes, la Corniche Ouest accueillera également les 10 sports d’engagement dans l’espace « Let’s Move »."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 30-title\" style=\"top:158px;left:43px;\" src=\"/126/static/_content/30-title-1.png\"/>\n      <img class=\"abs halfScale 30-title\" style=\"top:290px;left:43px;\" src=\"/126/static/_content/30-title-2.png\"/>\n      <img class=\"abs halfScale 30-title\" style=\"top:410px;left:43px;\" src=\"/126/static/_content/30-title-3.png\"/>\n      <img class=\"abs halfScale 30-sub\" style=\"top:543px;left:43px;\" src=\"/126/static/_content/30-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.staggerFromTo(cOf(\"30-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)\n          .fromTo(cOf(\"30-sub\"), 0.9, {opacity:0, y:45}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4);\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n        }\n      ",
    "searchText": "GÉNÉRATiON·S DAKAR 2026 LEARNiNG ACADEMY PROGRAMME IN…DIT DE FORMATION ET DE RECRUTEMENT DE JEUNES DIPL‘M…S, LA DAKAR 2026 LEARNING ACADEMY ENTEND DOTER PLUS DE 400 PERSONNES DES COMP…TENCES PROFESSIONNELLES ET HUMAINES N…CESSAIRES ¿ LíORGANISATION Dí…V…NEMENTS SPORTIFS ¿ Lí…CHELLE INTERNATIONALE. LE SUCC»S DE CETTE INITIATIVE QUI A D…PASS… LES ATTENTES ET LES FRONTI»RES DU S…N…GAL EST AU CåUR DE LíH…RITAGE DES JEUX OLYMPIQUES DE LA JEUNESSE (JOJ) DE DAKAR 2026. PAR LAURIANE NEMBROT  Sokhna Dia fait partie des jeunes diplômés inscrits à la Learning Academy."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:289px;left:260px;width:155px;height:14px;\">  \n        <a href=\"https://www.olympics.com/cio/news/ils-construisent-demain-l-academie-de-formation-de-dakar-2026-presente-ses-premiers-talents\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:302px;left:260px;width:102px;height:14px;\">  \n        <a href=\"https://www.olympics.com/cio/news/ils-construisent-demain-l-academie-de-formation-de-dakar-2026-presente-ses-premiers-talents\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "32  Dakar 2026 Learning Academy  B  uenos Aires, 8 octobre 2018. La 133e Session du Comité international Olympique (CIO) se déroule en Argentine, pendant la troisième édition des Jeux Olympiques de la Jeunesse (JOJ) d’été, après une première édition de lancement organisée à Singapour en 2010, suivie par celle de Nanjing quatre ans plus tard. À l’issue de séances de discussions et d’un vote d’approbation, Dakar est annoncée comme prochaine ville hôte des JOJ. L’événement était initialement prévu en 2022, mais la pandémie mondiale de COVID-19 est venue tout bouleverser. Malgré un report de quatre ans, la décision demeure historique. Nous sommes en 2026 et le Sénégal s’apprête bel et bien à accueillir le tout premier événement sportif olympique organisé en Afrique du 31 octobre au 13 novembre. Une fois l’euphorie passée, des questions émergent. La presse francophone internationale, notamment, s’interroge : le continent bénéﬁcie-t-il, à date, des ressources humaines et opérationnelles en nombre suffisant pour organiser un tel événement ?  1  Les membres du comité d’organisation des Jeux Olympiques de la Jeunesse (COJOJ) de Dakar 2026, officiellement créé en février 2020, s’emparent du sujet dès leur entrée en fonction. La décision est prise : pour parvenir à organiser le premier événement olympique en Afrique, le COJOJ recrutera et formera la majeure partie de sa main-d’œuvre opérationnelle au Sénégal et sur le continent. Avec l’ambition de faire émerger les talents africains dans les domaines de l’événementiel sportif, cette vision s’inscrit dans l’ADN inclusif de leur slogan « l’Afrique accueille, Dakar célèbre ».  2  Les débuts de la Dakar 2026 Learning Academy Dakar, mai 2026. Dans son bureau du COJOJ, Fatimata Diaw, responsable du protocole, se remémore les débuts de la Dakar 2026 Learning Academy. C’est à la suite d’échanges conjoints organisés à Paris durant l’été que ce projet a vu le jour, lorsque le CIO a présenté pour la première fois le concept au COJOJ. En novembre 2024, à son arrivée au comité d’organisation, elle était justement chargée  1 Un groupe de participants issus de la première cohorte de la Learning Academy. 2 La Learning Academy vise à doter les participants de compétences professionnelles et humaines. 3 Ces jeunes professionnels contribueront activement à l’organisation des prochains JOJ."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  33  Numéro 126  de lancer ce projet. « Hormis une slide de PowerPoint, il n’y avait rien, aucune information, tout était à faire, dit-elle. Au début, personne n’y croyait vraiment. » Sous la houlette de Bocar Laurent Sy, directeur exécutif et directeur des ressources humaines de Dakar 2026, une petite équipe se forme autour de Fatimata Diaw et Felix Gaye en charge de la workforce du COJOJ, en étroite collaboration avec une équipe du CIO. Tous travaillent d’arrache-pied pour mettre en place le programme. « Il a fallu enchaîner les réunions, chercher les partenaires, élaborer un plan de recrutement. Il fallait faire vite, on devait lancer la première cohorte de la Learning Academy début 2025 », souligne Fatima Diaw. Mais très vite, d’autres obstacles font surface. La jeune équipe, motivée à bloc et déterminée à mener à bien ce projet, se heurte à de nombreuses réticences. « Pour la majorité des personnes au sein du COJOJ, il était très difficile, voire impossible, de concevoir qu’on allait livrer les JOJ avec des personnes qui n’avaient jamais fait ça auparavant », se souvient Fatimata Diaw. Installé à ses côtés, Felix Gaye résume aussi le chantier que cela a représenté, mais rappelle tout l’intérêt d’une telle entreprise. « Il s’agit de postes que la plupart des gens qu’on allait recruter n’avaient jamais exercés auparavant, explique-t-il. Il n’y a pas forcément d’expérience existante sur le terrain. Lorsqu’on construit un comité d’organisation, la stratégie de recrutement ne peut pas être de dire : “Nous allons recruter 100 % de personnes venant d’autres comités d’organisation.” Ce n’est tout simplement pas comme cela que ça fonctionne. Et puis, pour les premiers JOJ en Afrique, il faut aussi, dans une certaine mesure, que ce soient des Africains qui les organisent et les livrent. » Pourtant, l’équipe fait ﬁ des incertitudes et se concentre sur la ﬁnalité du projet : lancer la Dakar 2026 Learning Academy, abrégée « LA » en interne. Cette formation intensive, délivrée en partie par le CIO et destinée aux jeunes diplômés âgés de 21 à 35 ans qui souhaitent faire partie de l’organisation de Dakar 2026, est inédite. En e%et, dans l’histoire des Jeux Olympiques et du CIO, aucun autre comité d’organisation n’a mis en place un tel dispositif. Le COJOJ et le CIO, soucieux de coller au plus près du concept d’inclusion continental, invitent également chaque Comité National  3  Olympique africain à désigner un candidat pour s’engager dans l’aventure et proﬁter de l’expérience de la Learning Academy. Cette initiative sera soutenue avec enthousiasme par la Solidarité Olympique. Ce concept s’étendra aussi à la participation d’olympiens qui se verront o%rir une opportunité de reconversion professionnelle après leur carrière de sportifs de haut niveau.  Révéler le potentiel africain Bocar Laurent Sy, fort de longues années à sillonner le monde en tant que responsable des ressources humaines de plusieurs multinationales, a pu observer de près le modèle de recrutement en vigueur dans les pays nordiques. Il s’en est inspiré pour bâtir le recrutement des participants. « Ça a été très long, souvent di%icile, on n’est pas toujours tombé d’accord, il y a eu des moments de tensions, se remémore-t-il. Mais je n’ai jamais douté de la faisabilité de ce projet. Le format initial a beaucoup évolué. Mais le soir du lancement de la première cohorte, en avril  2025, quand on a vu tous les participants réunis, on a compris qu’on avait fait le bon choix. » Mise à disposition de la Learning Academy, cette expertise a notamment permis à des proﬁls atypiques et inspirants de rejoindre le COJOJ et de participer activement à l’organisation du tout premier événement sportif olympique en Afrique. À l’instar de Sokhna Dia, 25 ans. Après avoir terminé ses études à l’université, elle n’a pas trouvé de travail dans sa ﬁlière et a rejoint une entreprise de nettoyage. Son premier contrat : s’occuper des bureaux du COJOJ. Pendant des séances intensives de ménage, Sokhna Dia observe de loin les préparatifs. Fascinée par tout ce qu’elle peut voir, elle décide de s’abonner aux réseaux sociaux du COJOJ. C’est ainsi qu’elle découvre l’appel à candidatures pour le recrutement de la première promotion de la Learning Academy. « Pour compléter le dossier de candidature, on nous a demandé de réaliser une vidéo de présentation, dit-elle. J’ai décidé de faire"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n      \n      <h1 id=\"34-no\" class=\"abs olympicHeadlineComp 34-no\" style=\"top:492px;left:80px; font-size: 6.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 11928, \"comma\": true}' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs olympicHeadlineComp 34-no\" style=\"top:492px;left:309px; font-size: 6.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 263}' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs olympicHeadlineComp 34-no\" style=\"top:589px;left:274px; font-size: 4.6em; font-weight: 300; color: #a0d5b3; padding: 0px; margin: 0px;\" data-number='{\"to\": 29}' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs olympicHeadlineComp 34-no\" style=\"top:589px;left:388px; font-size: 4.6em; font-weight: 300; color: #a0d5b3; padding: 0px; margin: 0px;\" data-number='{\"to\": 27}' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs olympicSansBd 34-no\" style=\"top:757px;left:309px; font-size: 0.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 49.4, \"append\" : \"%\", \"decimals\" : 1 }' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs olympicSansBd 34-no\" style=\"top:757px;left:361px; font-size: 0.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 50.6, \"append\" : \"%\", \"decimals\" : 1 }' ></h1>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.fromTo(cOf(\"34-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"34-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[1])}}, 1.0)\n          .fromTo(cOf(\"34-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[2])}}, 1.1)\n          .fromTo(cOf(\"34-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[3])}}, 1.1)\n          .fromTo(cOf(\"34-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[4])}}, 1.2)\n          .fromTo(cOf(\"34-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[5])}}, 1.2);\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n          resetNumbers(\"34-no\");\n        }\n      ",
    "searchText": "34  Dakar 2026 Learning Academy  1  la mienne dans les bureaux du COJOJ, quand je faisais le ménage un matin. » La démarche est saluée par les recruteurs de la Learning Academy, qui identiﬁent la motivation sans borne de Sokhna Dia. La jeune femme est aujourd’hui coordinatrice du village olympique de la jeunesse. Pour Pape Moussa Sarr, chargé de recrutement, « le parcours de Sokhna Dia illustre parfaitement le pouvoir transformateur et le potentiel de ce programme ». L’évolution de la jeune femme « démontre qu’avec une formation adaptée et un accompagnement de qualité, les jeunes Sénégalais et Africains sont capables d’accomplir des choses remarquables, au même titre que les autres jeunes à travers le monde, voire davantage. »  Un impact au-delà de l’Afrique  1  LA LEARNiNG ACADEMY EN QUELQUES CHiFFRES  11 928  Nombre total de candidatures :  263  Nombre de participants :  29  Nationalités  27  Âge médian  Répartition par genre  49,4 % 50,6 % d’hommes de femmes  L’engouement pour la Dakar 2026 Learning Academy dépasse toutes les espérances. Des milliers de candidatures sont recensées et le chiffre augmente signiﬁcativement à chaque nouvelle vague de recrutement. À Lausanne, au siège du CIO, la Learning Academy mobilise également les membres de l’administration du CIO qui s’engagent en tant qu’instructeurs pendant les semaines de formation, décomposées en plusieurs volets. Les deux premières semaines sont orientées sur la connaissance du Mouvement olympique, les sports de compétition, les parties prenantes, le fonctionnement des différents départements du comité d’organisation et l’importance du travail collaboratif. Des visites de sites de compétition sont aussi organisées aﬁn de se familiariser avec les opérations in situ. La troisième semaine est consacrée au développement personnel : gestion du stress, prise de parole en public… De nombreux outils sont mis à disposition et compilés dans un Learning Journal, considéré comme la bible des participants. « Pour certains, peut-être la plupart, les compétences sont déjà là », assure FrançoisMarie Bourgeois, Senior Project Manager au département des Sports du CIO qui est venu au Sénégal plusieurs fois depuis le début du programme et a animé des ateliers de formation pour chaque cohorte.  1 Plus de 260 personnes ont été retenues pour la formation."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Open always wins Victory is a team sport  Image simulated. UX/UI may differ."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 36-quote\" style=\"top:694px;left:68px;\" src=\"/126/static/_content/36-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 36-quote-img\" style=\"top:649px;left:-22px;\" src=\"/126/static/_content/36-quote-img-1.png\"/>\n    \n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim.fromTo(cOf(\"36-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"36-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n        }\n      ",
    "searchText": "36  Dakar 2026 Learning Academy  1  « Ce programme leur permet d’acquérir des connaissances. Après leur formation et une fois qu’ils intègrent leurs départements, on a noté que les participants sont plus opérationnels. Ils savent de quoi on parle, ils apprennent plus vite et ils ont une vue d’ensemble du sujet. C’est un accélérateur. » « De toutes les formations que j’ai faites, je n’ai jamais vu un tel degré de positivité dans un groupe. Le niveau de motivation individuelle et collective est inégalé », complète Aurélie Lemouzy, Senior Legacy Manager au département des Jeux Olympiques du CIO, elle aussi instructrice à la Learning Academy.  Un héritage pour demain Les compétences professionnelles et humaines assimilées lors de cette formation et l’expérience d’avoir participé à l’organisation du premier événement sportif olympique organisé en Afrique font d’ores et déjà partie de l’héritage de ces JOJ. Ibrahima Wade, coordinateur général du COJOJ et haut fonctionnaire de la fonction publique sénégalaise, se dit persuadé que les participants « sauront tirer pleinement parti des opportunités offertes à l’issue de cette expérience véritablement exceptionnelle ». Selon lui, la Dakar 2026 Learning Academy  « Les compétences [que les participants] auront acquises leur seront précieuses et transférables dans n’importe quel secteur. »  est « indéniablement un programme exigeant, mais d’une richesse incomparable. » Avant de conclure : « Les compétences qu’ils auront acquises, autant lors de l’événement que tout au long des phases de planiﬁcation et de préparation, leur seront précieuses et transférables dans n’importe quel secteur d’activité. » Si le Sénégal tire déjà proﬁt des ressources opérationnelles passées par ce programme, l’avenir de la « LA » semble prometteur. À l’issue des premiers JOJ africains, ce modèle d’apprentissage pourrait être répliqué lors des éditions futures des Jeux Olympiques. L’histoire retiendra peut-être que la ville hôte des prochains Jeux Olympiques partage les mêmes initiales que le projet phare de formation de Dakar 2026... Un signe du destin ? ■  IBRAHIMA WADE 1 Les participants à la Learning Academy au stade olympique de Diamniadio."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 38-title\" style=\"top:386px;left:42px;\" src=\"/126/static/_content/38-title-1.png\"/>\n      <img class=\"abs halfScale 38-title\" style=\"top:542px;left:44px;\" src=\"/126/static/_content/38-title-2.png\"/>\n      <img class=\"abs halfScale 38-sub\" style=\"top:700px;left:44px;\" src=\"/126/static/_content/38-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.staggerFromTo(cOf(\"38-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)\n          .fromTo(cOf(\"38-sub\"), 0.9, {opacity:0, y:45}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4);\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n        }\n      ",
    "searchText": "UNE ViTRiNE CULTURELLE PREMIER …V…NEMENT OLYMPIQUE SUR LE CONTINENT AFRICAIN, LES JEUX OLYMPIQUES DE LA JEUNESSE DE DAKAR 2026 SONT AUSSI LíOCCASION DE METTRE EN AVANT UN SAVOIR-FAIRE, UN PATRIMOINE CULTUREL ET HISTORIQUE ENCORE PEU CONNU DU MONDE. PAR CÉLIA CUORDIFEDE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Les JOJ de Dakar 2026 seront une célébration de la culture, de la musique et de l’art urbain."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "40  Feature: Dakar 2026 Overview  1  D  ans les rues de Dakar, la bouillonnante capitale sénégalaise, l’histoire des Jeux Olympiques de la Jeunesse (JOJ) est en train de s’écrire. Partout, elle se répand avec une vive douceur comme le chuchotement d’un griot au commencement d’un conte populaire. C’est la première fois que des JOJ auront lieu en Afrique. Au ﬁl des jours, ce mythe fait de prouesses sportives, de découvertes et de promotion des cultures locales conquiert la ville, le cœur de la nation, et même le continent. Il devient réel, souvent grâce au bouche-à-oreille, et parfois avec des représentations symboliques ou des événements bien marqués. En ces instants, la ferveur et la hâte gagnent du terrain. L’événement, qui se tient du 31 octobre au 13 novembre 2026 entre les villes de Dakar, Saly et Diamniadio, attise chaque jour un peu plus la curiosités et les appétits créatifs. Si aujourd’hui « l’Afrique accueille, Dakar célèbre » (Afrig Dalal, Ndakaaru Jëmël en wolof), pour reprendre la devise officielle de Dakar 2026, il y a longtemps que Dakar inspire, innove et envoûte – ceux qui  ont déjà foulé le sol de la presqu’île le savent déjà. Les JOJ sont l’occasion de le démontrer au reste du monde. Alors, en parallèle de l’événement sportif, la culture se met, elle aussi, dans la course des JOJ. « Les Jeux Olympiques de la Jeunesse de Dakar 2026 ne sont pas simplement une première africaine sur le plan sportif. Ils constituent une première historique au sens plein, quasi civilisationnelle », consent Mamadou Diagna Ndiaye, président du Comité National Olympique et Sportif Sénégalais (CNOSS) et du comité d’organisation de Dakar 2026. « La culture y est essentielle parce qu’elle est ce par quoi une nation et un continent se disent au monde. Elle donne du sens à l’événement, elle lui confère une profondeur que le sport, à lui seul, ne saurait atteindre », poursuit-il avec enthousiasme. 1 Le Monument de la Renaissance africaine, sur les collines de Dakar, est un repère emblématique. 2 L’impressionnante fresque à la gare de TER dans le quartier de Colobane, cocréée par l’artiste Zeinixx.  À travers les générations Dans la nuit dakaroise d’un mois de mai encore frais, où les bourrasques de poussière saharienne caressent les murs défraîchis, Souleymane Diop, un commerçant propriétaire d’une boutique au marché artisanal de Soumbédioune, n’a pas fait le déplacement jusqu’à la gare de TER ﬂambant neuve du quartier de Colobane par hasard. Une rumeur circule en ville sur une œuvre exposée en plein cœur de Dakar. « Elle est bien là », conﬁrme-t-il, selﬁe à l’appui. Face à lui s’élève une immense fresque aux couleurs vives de près de sept mètres par quatre. Estampillée du logo des Jeux Olympiques de la Jeunesse « Dakar 2026 Youth Olympic Games », elle présente les portraits de trois sportives sénégalaises. « C’est vraiment beau », commente Souleymane Diop aux côtés d’autres badauds curieux. Au bas du mur, teinté de bleu ciel, c’est d’abord le visage gaillard et iconique de Julie Marie Gomis, première olympienne du pays en 1976 lors de l’épreuve de 100 m haies,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 41-quote\" style=\"top:203px;left:387px;\" src=\"/126/static/_content/41-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 41-quote-img\" style=\"top:37px;left:412px;\" src=\"/126/static/_content/41-quote-img-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim.fromTo(cOf(\"41-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"41-quote\"), 0.9, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n        }\n      ",
    "searchText": "Revue Olympique  41  Numéro 126  2  « La culture est essentielle parce qu’elle est ce par quoi une nation et un continent se disent au monde. » MAMADOU DIAGNA NDIAYE  qui se laisse découvrir. Vient ensuite la mine déterminée de la céiste Combé Seck, 30 ans. Championne d’Afrique de canoë sprint en 2025, elle a été l’une des deux porte-drapeaux du Sénégal aux Jeux de Paris en 2024. Au sommet, c’est le visage juvénile et plein d’espoir de Tening Faye, 15 ans, médaillée de bronze aux Championnats du monde cadets de taekwondo dans sa catégorie à Fujairah aux Émirats arabes unis en 2025, qui achève ce tableau des générations d’athlètes sénégalaises. « C’est génial, je ne savais pas qu’il y avait tout ça. C’est une amie qui me l’a dit et j’ai voulu le constater par moi-même, poursuit Souleymane Diop. C’est une bonne idée pour que les gens commencent à se préparer à l’événement. Ça donne envie d’en savoir plus, d’aller plus loin », témoigne-t-il plein d’entrain. Apparue en mars dernier sur le mur de la gare de TER la plus fréquentée de la capitale, l’œuvre ne passe pas inaperçue dans les rues animées de Dakar, où le jaune et le bleu chatoyants des cars rapides et autres vieux taxis sont omniprésents. « Les couleurs vives et l’esthétisme des motifs dans le fond de la fresque, c’est pour montrer l’importance de l’accueil au Sénégal et plus largement au Sahel et en Afrique », explique Dieynaba Sidibe, alias Zeinixx, graffeuse et coauteure de la peinture murale. L’artiste de 35 ans, première graffeuse sénégalaise de l’histoire, a de nouveau innové. Elle a été la première à s’élancer pour faire"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:294px;left:169px;width:76px;height:14px;\">  \n        <a href=\"https://www.olympics.com/en/news/senegalese-artist-serigne-mansour-fall-painting-purpose-art-responsibility\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:308px;left:44px;width:17px;height:14px;\">  \n        <a href=\"https://www.olympics.com/en/news/senegalese-artist-serigne-mansour-fall-painting-purpose-art-responsibility\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "42  Une vitrine culturelle  parler les murs de la capitale dans le cadre 1 du projet dénommé « Yeesal » (un terme wolof), dont l’objectif est de mettre l’art urbain au cœur des JOJ. Pour l’occasion, Dakar et ses banlieues populaires dont Ruﬁsque et Bargny, mais également Diamniadio et Saly, s’apprêtent à devenir une galerie à ciel ouvert. Au total, 43 fresques réalisées par 43 graffeurs doivent être peintes dans les prochaines semaines sur les murs, de gares principalement, en sept mètres par quatre. « Le projet “Yeesal” offre aux jeunes la chance de s’exprimer, d’apporter leur touche artistique aux JOJ », souligne Serigne Mansour Fall, graffeur plus connu sous le nom de Mad Zoo, chargé de la direction artistique du projet. « Il ne s’agit pas seulement de fresques décoratives. On parle de fresques engageantes et de remise en perspective des succès sportifs du continent. »  populations sur les problèmes d'hygiène et de santé publique. « Le fait que le graff soit aujourd’hui appelé pour les JOJ est un vrai symbole de notre culture, une reconnaissance et surtout une immense ﬁerté », se réjouit-elle. D’autant que grâce à ces fresques murales en lien avec les JOJ qui s’apprêtent à ﬂeurir dans les quartiers, la vocation première du graffiti, à savoir l’éducation par le dessin, est remise à l’honneur. « Plus on fera de fresques, plus les gens auront accès aux informations sur les JOJ, l’histoire des sports et de nos héros, plus l’engouement sera grand, croit Mad Zoo. Il était essentiel que l’organisation saisisse l’importance de notre communication culturelle, dont les graffs font partie, pour déclencher l’engouement populaire et que l’on fasse de ces Jeux un truc à nous et pour nous, pas seulement sportivement parlant. »  « Un vrai symbole de notre culture »  Apporter la joie  La quarantaine de graffeurs, sélectionnés au cours des derniers mois grâce à un appel à projets, a d’ores et déjà proposé des visuels sur 1 le thème de l’héritage sportif, des valeurs de l’Olympisme (l’amitié, le respect et l’excellence) et de la diversité culturelle. Comme celle de Zeinixx, représentant trois générations d’athlètes sénégalaises, la plupart des fresques s’apprêtent à mettre en lumière des succès, parfois oubliés ou méconnus, d’athlètes. « Au-delà du sport, l’idée est de valoriser le street art, de donner la chance à des jeunes artistes de participer aux JOJ et de promouvoir leur talent artistique et, pourquoi pas, de lancer des carrières », relève Serigne Mansour Fall. Au Sénégal, où le graff n’est pas interdit, mais toléré, la participation officielle d’un tel projet de street art sonne à la fois comme « une continuité pour un art qui a toujours été au service de la société », pense la graffeuse Zeinix. Dans ce pays d’Afrique de l’Ouest, le graffiti est né dans l’esprit du mouvement Set/Setal au début des années 1990. À l’époque, des milliers de jeunes avaient réquisitionné les murs de leurs quartiers pour communiquer au sujet de grandes opérations de nettoyage, peignant des fresques pour informer les  À l’image du projet « Yeesal », une myriade d’actions faisant dialoguer l’art et le sport sur l'intégralité du territoire sénégalais ont été lancées au cours des deux dernières années, le plus souvent par le biais d’appels à projets ou de concours. Parmi les plus emblématiques ﬁgure celui du dessin pour la mascotte de Dakar 2026. Organisé ﬁn 2025, l’événement a été piloté directement par le ministère de l’Éducation  1 Ayo, le lionceau mascotte de Dakar 2026, a diffusé le message des JOJ à travers tout le Sénégal. 2 Au total, 43 fresques murales seront réalisées par des graffeurs dans le cadre du projet « Yeesal ».  1  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 43-quote\" style=\"top:552px;left:80px;\" src=\"/126/static/_content/43-quote-text-1.png\"/>\n      <img class=\"abs halfScaleC 43-quote-img\" style=\"top:506px;left:-22px;\" src=\"/126/static/_content/43-quote-img-1.png\"/>\n\n      <div class=\"contentLink\" style=\"top:768px;left:55px;width:91px;height:14px;\">  \n        <a href=\"https://www.olympics.com/fr/infos/joj-dakar-2026-decouvrez-ndeye-mariama-diop-la-jeune-designer-derriere-mascotte-ayo\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim.fromTo(cOf(\"43-quote-img\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"43-quote\"), 0.9, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  43  Issue 126  « Le fait que le graff soit appelé aujourd’hui pour les JOJ est un vrai symbole de notre culture [et] une immense fierté. » ZEINIXX  nationale du Sénégal auprès de 500 élèves issus de 41 établissements dans 16 régions à travers le pays. Après trois tours de sélection, la compétition a ﬁnalement consacré l’œuvre de Ndeye Mariama Diop, une jeune ﬁlle de 16 ans originaire de Saint-Louis, l’une des principales villes du pays, située à la frontière avec la Mauritanie. Passionnée de dessin et de mangas depuis l’enfance, la lycéenne s’est inspirée de son  quotidien pour ancrer le personnage « à la fois dans les traditions sénégalaises et dans la modernité », conﬁe-t-elle. Dénommé Ayo (« joie » en yoruba – une langue largement parlée en Afrique de l’Ouest), le lionceau possède un visage guilleret. « Je m’étais dit que le personnage ne devait pas être austère, mais plutôt rigolo, pour que les enfants s’y attachent et qu’il apporte la joie là où il passerait », explique Ndeye Mariama  Diop. Ayo est en outre coiffé d’un tingandé (le chapeau traditionnel peul, une communauté très présente dans la région) et porte un maillot de foot, un sport populaire auprès des jeunes. « J’ai voulu mélanger les habits traditionnels et contemporains et, dans un souci d’inclusion, faire un clin d’œil aux talibés [les enfants des rues traditionnellement conﬁés par leurs proches à des écoles coraniques pour leur éducation religieuse], qui sont le plus souvent vêtus de maillots bon marché que l’on retrouve partout sur les étals du pays », raconte-t-elle avec maturité. Et d’ajouter : « J’ai pensé cette mascotte comme une opportunité d’avoir un exemple de personnage ﬁctif qui représente le Sénégal de façon positive dans le monde. » Symbole d’unité avant le début des Jeux Olympiques de la Jeunesse, la mascotte a même été présentée devant le président de la République Bassirou Diomaye Faye."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:295px;left:589px;width:45px;height:14px;\">  \n        <a href=\"https://www.olympics.com/fr/infos/dakar-2026-devoile-les-uniformes-des-volontaires-pour-les-ceremonies-des-vainqueurs\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:306px;left:520px;width:69px;height:14px;\">  \n        <a href=\"https://www.olympics.com/fr/infos/dakar-2026-devoile-les-uniformes-des-volontaires-pour-les-ceremonies-des-vainqueurs\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "44  1  UN ESPRiT CÉRÉMONiEL Conçues par la maison de mode sénégalaise Algueye Dakar, les tenues des volontaires pour les cérémonies des vainqueurs de Dakar 2026 s’inscrivent dans une approche résolument minimaliste, aﬁn de laisser toute la lumière aux athlètes. Mettant en valeur la créativité et le savoir-faire des artisans sénégalais, ce design contemporain célèbre la richesse culturelle du pays hôte. La silhouette se distingue par un col tulipe et un pagne tissé, symbole fort de l’habillement et de la mode en Afrique de l’Ouest. 1  2  « Les JOJ de Dakar 2026 seront un moment de rayonnement pour le Sénégal et pour l’Afrique. À six mois de l’ouverture des compétitions, notre pays compte sur la mobilisation du monde des arts et de la culture pour relever ce déﬁ national et ce pari continental », a déclaré le chef de l’État en avril dernier.  « Une puissance internationale » Tant sur le volet économique, social et culturel, les JOJ représentent plus que jamais un jalon à l’échelle de ce pays de 18 millions d’habitants. « Les JOJ, comme tous les événements internationaux, sont une véritable vitrine vers les savoir-faire, vers les acteurs institutionnels et privés, et sont l’occasion de montrer au monde entier ce qu’est le Sénégal sous toutes ses coutures », souligne Jean-Baptiste Guégan, spécialiste en géopolitique du sport,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  45  Numéro 126  chargé de cours à Sciences Po Paris sur l’histoire et la géopolitique du sport africain. Il y a une dimension de diplomatie publique et a fortiori culturelle, que certains seraient tentés de réduire à du soft power, mais cela va bien au-delà. Par cet événement, Dakar s’inscrit dans une logique de puissance continentale, régionale et internationale ». Dans la continuité du narratif de ces JOJ dont les initiatives essaiment un peu partout dans la jeune société sénégalaise, le lionceau Ayo, qui a désormais pris vie sous la forme d’une peluche géante, réalise une tournée à travers le territoire. Comme un vecteur d’information de l’événement historique à venir, Ayo fait, lui aussi, passer des messages, à l’instar des graffeurs du projet « Yeesal ». Les étapes de sa tournée mettent à l’honneur le patrimoine historique et culturel sénégalais. Début mars dernier, la mascotte a ainsi foulé le sol de l’île de Gorée, symbole mondial de la traite négrière transatlantique. Après un bref passage dans la prestigieuse école de ﬁlles Mariama Bâ, du nom de la célèbre écrivaine sénégalaise, le lionceau est parti à la découverte de la Maison des Esclaves et de la Porte du non-retour, où les esclaves embarquaient vers les colonies. La visite, riche en émotions et lourde d’histoire, devrait être un incontournable des visiteurs pendant les JOJ. Ayo a donné la direction. Dans la même veine que le concours de dessin pour la mascotte, l’hymne des JOJ doit être dévoilé d’ici ﬁn juin. Il accompagnera les épreuves dans les arènes de lutte (le sport national ultra-populaire) – dont certaines sont transformées pour accueillir d’autres épreuves – sur les plages qui bordent l’Atlantique et dans les stades ﬂambant neufs. Le morceau qui animera les deux semaines de compétition doit être révélé à l’issue d’un concours entre 50 propositions sonores. Intitulé le « Wonéel sa bop » (« Révèle-toi » en wolof), le projet a mobilisé une large partie de l’industrie musicale du pays, des artistes interprètes aux instrumentistes, beatmakers, producteurs et compositeurs. C’est l’occasion de révéler au monde la force de la culture musicale sénégalaise, née des chants de 1 Les tenues des bénévoles pour les cérémonies des vainqueurs rendent hommage à la richesse culturelle du Sénégal. 2 Une danse traditionnelle à Obama Beach à Saly. 3 Samba Peuzzi se produit sur scène lors du concert d’ouverture de Dakar en Jeux en 2023.  3  3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"contentLink\" style=\"top:303px;left:208px;width:28px;height:14px;\">  \n        <a href=\"https://www.olympics.com/cio/dakar-2026-culture\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"top:317px;left:42px;width:38px;height:14px;\">  \n        <a href=\"https://www.olympics.com/cio/dakar-2026-culture\" target=\"_blank\"></a>\n      </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Revue Olympique  47  Numéro 126  griots et aujourd’hui largement popularisée par le mbalax, dont le « roi » Youssou N’dour, comme il est surnommé ici, doit être partie prenante du jury. Pour la fabrication des médailles ainsi que la confection des tenues des athlètes sénégalais, des appels à projets de jeunes créateurs et artisans originaires de tout le pays ont, là encore, été privilégiés. « Il se passe beaucoup de choses, c’est très stimulant comme environnement pour la création », apprécie Mouhamadou El Amine Diallo, fondateur de la marque de mode Kamal Raw et participant à un déﬁlé de mode en novembre dernier à l’occasion de la quatrième édition de l’événement Dakar en Jeux. Depuis 2022, ce festival culturel et sportif annuel s’est donné pour mission de faire monter en puissance les aspects techniques de l’organisation des JOJ et de faire grimper la ferveur populaire.  « Une Afrique en mouvement » Si les JOJ de Dakar 2026 doivent offrir une véritable plateforme aux athlètes de demain, le CNOSS s’est attelé à ce que l’événement soit doté de la même résonance pour le reste de la jeunesse. « Dans toutes les éditions qui ont été organisées, la dimension culturelle, au-delà du sport, est l’une des dynamiques les plus importantes », rappelle Fanta Diallo, directrice de l’engagement et de la mobilisation auprès du comité d’organisation de Dakar 2026. « Nous avons tenu à suivre ce précepte. Puisque l’on parle de Jeux Olympiques de la Jeunesse, il était encore plus important d’ouvrir des possibilités aux jeunes pour montrer leur créativité et faire en sorte qu’eux aussi puissent apporter leur pierre à l’édiﬁce ». Persuadé que ces Jeux doivent être un catalyseur social et éducatif, le CNOSS a en outre lancé un label pour permettre à de multiples entités, institutions, acteurs privés et autres associations de s’impliquer dans le programme des JOJ partout au Sénégal. La demande est grandissante. « À condition de transmettre les valeurs de l’Olympisme que sont l’amitié, le respect et l’excellence, mais aussi offrir des opportunités, surtout d’apprentissage à la jeunesse », précise Fanta Diallo. Pendant les deux semaines de célébration, des festivals, concerts, spectacles urbains, déﬁlés de mode et autres animations populaires devraient se tenir près des sites  2  de compétition et dans les villes hôtes à Dakar, Diamniadio et Saly. Au-delà du sport, les JOJ sont aussi l’occasion de montrer la capacité du Sénégal à accueillir un événement international d’envergure, encouragé par tout un continent. Un narratif revigorant alors que l’Afrique est rarement perçue avec un ﬁltre positif. « Par ces Jeux, nous voulons montrer une Afrique en mouvement, inventive, audacieuse, qui ne se contente pas d’hériter, mais qui crée, innove et inﬂuence », conclut Mamadou Diagna Ndiaye. ■  1 Une mannequin lors d’un déﬁlé de mode dans le cadre du festival Dakar en Jeux. 2 Des percussionnistes se produisent à Obama Beach à Saly."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 48-title\" style=\"top:595px;left:36px;\" src=\"/126/static/_content/48-title-1.png\"/>\n      <img class=\"abs halfScale 48-title\" style=\"top:736px;left:106px;\" src=\"/126/static/_content/48-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.staggerFromTo(cOf(\"48-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1);\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 49-sub\" style=\"top:803px;left:212px;\" src=\"/126/static/_content/49-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim.fromTo(cOf(\"49-sub\"), 0.9, {opacity:0, y:-30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4);\n        }\n\n        function onPageLeave() {\n          pg49Anim.stop();\n        }\n      ",
    "searchText": "DANS UNE SÉRIE D’IMAGES PERCUTANTES, LES PHOTOGRAPHES SÉNÉGALAIS SIDY TALLA ET BADARA PREIRA CAPTURENT L’ÉNERGIE DE LA SCÈNE SPORTIVE DAKAROISE, QUI SE MÊLE AU RYTHME DE LA VIE QUOTIDIENNE."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 50-title\" style=\"top:102px;left:46px;\" src=\"/126/static/_content/50-title-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax();\n          pg50Anim.fromTo(cOf(\"50-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1);\n        }\n\n        function onPageLeave() {\n          pg50Anim.stop();\n        }\n      ",
    "searchText": "50  À travers l’objectif  LES PHOTOGR APHES  SIDY TALLA Sidy Talla (auteur de la couverture) est un photographe, designer graphique et ingénieur du son sénégalais, reconnu pour son travail dans la photographie sportive et la création visuelle. Il est le fondateur et directeur artistique d’Eyelit Studio, un studio basé à Dakar spécialisé dans la photographie, la création d’identités visuelles et la production de supports de communication. Son approche artistique consiste à raconter des histoires à travers ses clichés, notamment dans le sport, où il est particulièrement actif. Aujourd’hui, Sidy Talla est l’un des photographes les plus sollicités dans le domaine du sport au Sénégal, collaborant avec divers organisations et événements sportifs pour capturer des moments mémorables.  BADARA PREIRA Photographe sénégalais, Badara Preira développe un travail centré sur l’humain, la mémoire et les réalités sociales contemporaines. Conscient que la photographie seule ne peut changer le monde, mais qu’elle peut participer à éveiller les esprits, il s’investit depuis plusieurs années dans des projets liés aux enfants des rues, aux sans-abris et aux réfugiés. Son approche documentaire et sensible l’a amené à collaborer avec plusieurs institutions et organisations internationales, notamment Greenpeace, l’Institut Français de Dakar, CHANEL, la Galerie du 19M ainsi que le Comité International Olympique, avec qui il a travaillé pour la première fois en 2022 autour de différents projets liés à Dakar 2026 et à la jeunesse sénégalaise.  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "51  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ST  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "54  À travers l’objectif  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "58  À travers l’objectif  BP  BP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BP  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "61  BP  ST"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 62-title\" style=\"top:128px;left:42px;\" src=\"/126/static/_content/62-title-1.png\"/>\n      <img class=\"abs halfScale 62-sub\" style=\"top:188px;left:43px;\" src=\"/126/static/_content/62-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg62Anim = new TimelineMax();\n          pg62Anim.fromTo(cOf(\"62-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"62-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg62Anim.stop();\n        }\n      ",
    "searchText": "62  Au-delà des anneaux  AU-DELÀ DES ANNEAUX  Une vision commune Directeur de l’Agence française de développement (AFD), Rémy Rioux évoque le partenariat avec le CIO pour faire du sport un moteur de développement sur le long terme.  C  et article est mon dernier en tant que directeur général de l’AFD. Après dix ans à la tête de notre institution au cœur de la politique de coopération et de développement de la France, je suis heureux de pouvoir prendre la plume pour remercier toutes les équipes du CIO et de l’AFD qui ont participé à bâtir ce partenariat couronné de succès. Les discussions entre l’AFD et le CIO ont débuté en 2019 et sont indissociables des Jeux Olympiques et Paralympiques de Paris 2024. C’est à travers les préparations pour les Jeux et la pandémie de la COVID-19 que nos institutions se sont liées et ont commencé à travailler ensemble, pour découvrir que nous partagions la même vision du sport en tant que moteur puissant de changement vers un monde plus sain, plus inclusif et plus pacifique. En 2020, l’AFD et Paris 2024 ont signé le premier partenariat de l’histoire entre un comité d’organisation des Jeux Olympiques et une banque publique de développement, afin de prolonger l’héritage des Jeux dans le temps et par-delà les frontières. Pour Paris 2024, nous avons lancé un incubateur d’entreprises visant à soutenir les projets entrepreneuriaux de 83 athlètes français et africains. Nous avons financé 45 projets de développement par le sport à travers 19 pays d’Afrique, puis avons accompagné une coopération étroite entre le Sénégal et la France pour soutenir le succès et l’héritage des Jeux Olympiques de la Jeunesse (JOJ) de Dakar 2026. Fort du succès de cette première coopération avec le Mouvement olympique, je me suis rendu à Lausanne en mars 2024 pour signer un accord ambitieux avec Thomas Bach, alors président du CIO. Nous souhaitions faire de ce partenariat un laboratoire permettant de tester comment  les organisations sportives internationales et les banques de développement peuvent agir de concert pour le sport, l’éducation, la paix et la croissance à long terme. Deux projets concrets sont nés de cette collaboration. Le premier, financé par la Fondation Laureus Sport for Good, promeut le sport au service de la formation et de l’insertion professionnelle en Afrique : il a déjà soutenu 29 organisations de la société civile. Le second, déployé dans quatre pays d’Asie du Sud-Est, soutient l’innovation sociale en utilisant le sport comme levier pour lutter contre la délinquance juvénile et promouvoir la réinsertion des jeunes ayant eu des démêlés avec la justice. Le CIO est également devenu un membre actif de la Coalition pour le développement durable par le sport, qui rapproche les banques publiques de développement et les institutions internationales engagées pour accroître les investissements dans le sport en faveur du développement. La mise en œuvre des engagements pris lors du Sommet du Sport pour le Développement Durable le 25 juillet 2024, à la veille de la cérémonie d’ouverture de Paris 2024, nécessite un engagement inflexible de la part de l’ensemble de la communauté internationale et du mouvement sportif. À travers sa stratégie Olympisme365, établie par la commission dont j’ai l’honneur d’être membre, le CIO est un partenaire clé et joue un rôle de leadership, souvent de pionnier, en ouvrant des espaces de dialogue et d’investissement commun. Parmi nos objectifs partagés figurent le renforcement des campagnes de soutien, la production de recherches pour mieux mesurer l’impact social du sport et l’accompagnement de l’innovation financière. L’organisation par le CIO du Sommet Olympisme365 en juin 2025, qui a conduit à l’adoption de 45 nouveaux  engagements représentant un investissement pouvant se monter à 200 millions d’USD, en est un parfait exemple. Les JOJ de Dakar 2026 qui pointent à l’horizon représentent un jalon dans notre partenariat. La coopération de l’AFD avec le Sénégal a mené à la modernisation de deux des principaux sites de compétition des Jeux, en plus de la création de 12 infrastructures sportives locales dans le Grand Dakar. Nous travaillons en collaboration étroite avec le CIO et le comité d’organisation de Dakar 2026 pour assurer un héritage durable à ces installations, afin d’offrir un accès au sport pour le plus grand nombre, et notamment pour les jeunes filles et les femmes. Je suis convaincu que ce premier événement olympique organisé sur le sol africain sera une formidable fête et montrera tout le potentiel de médailles de ce continent. D’ici 2030, l’Afrique représentera un tiers de la jeunesse mondiale – et bientôt, un tiers des médailles olympiques, espérons-le ! Je suis persuadé que la coopération entre le CIO et l’AFD dans les domaines du sport et du développement marque seulement le début d’une aventure encore plus ambitieuse et que bien plus de choses peuvent être accomplies avec l’ensemble de la communauté des banques publiques de développement au sein du mouvement Finance en Commun (FiCS). Ensemble, nous pouvons aller plus vite, plus haut et plus fort pour faire du sport un moteur de développement durable. ■  Spécialiste de l’économie et des institutions ﬁnancières internationales, Rémy Rioux a occupé des postes de haut niveau au cours d’une carrière consacrée au développement et à l’Afrique. Après avoir été chef de cabinet du ministre français de l’Économie et des Finances, il a été nommé secrétaire général adjoint du ministère des Aff aires étrangères et du Développement international. Rémy Rioux a été à la tête de l’AFD de 2016 à 2026."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 64-title\" style=\"top:625px;left:44px;\" src=\"/126/static/_content/64-title-1.png\"/>\n      <img class=\"abs halfScale 64-title\" style=\"top:737px;left:44px;\" src=\"/126/static/_content/64-title-2.png\"/>\n      <img class=\"abs halfScale 64-sub\" style=\"top:515px;left:187px;\" src=\"/126/static/_content/64-sub-1.png\"/>\n\n      <div class=\"addContentLink\" style=\"top:515px;left:189px;width:146px;height:14px;\">  \n        <a href=\"https://www.olympics.com/cio/news/le-cio-nomme-des-champions-olympiques-des-medailles-et-des-olympiens-comme-athletes-modeles-pour-les-joj-de-dakar-2026\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg64Anim = new TimelineMax();\n          pg64Anim.staggerFromTo(cOf(\"64-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1)\n          .fromTo(cOf(\"64-sub\"), 0.9, {opacity:0, y:-20}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg64Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Une athlète modèle anime une initiation au taekwondo à Buenos Aires en 2018.  LES ATHL»TES MOD»LES VONT AIDER LES JEUNES COMP…TITRICES ET COMP…TITEURS AU-DEL¿ DU SPORT. ¿ TRAVERS UN MENTORAT FOND… SUR LE PARTAGE DíEXP…RIENCE, ILS TRANSMETTRONT LES VALEURS OLYMPIQUES ¿ UNE NOUVELLE G…N…RATION.  INSPiRER LA GÉNÉRATiON SUiVANTE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "L  es Jeux Olympiques de la Jeunesse (JOJ) ne se sont jamais cantonnés à distribuer des médailles. S’ils offrent aux jeunes athlètes la possibilité de concourir sur l’une des plus grandes scènes sportives, leur impact durable se mesure surtout à l’expérience acquise loin des podiums. Depuis l’édition inaugurale des JOJ à Singapour 2010, les athlètes modèles soutiennent les générations suivantes, offrant leurs conseils pour accompagner les prouesses sportives des jeunes athlètes. Dakar 2026 ne fera pas exception. Quelque 36 athlètes modèles seront présents, représentant chaque sport en compétition et plusieurs sports d’engagement. Sélectionnés par leurs Fédérations Internationales, ils passeront les JOJ à jouer les mentors pour les participants par le biais d’activités pédagogiques, d’ateliers et de conversations informelles. Ces athlètes apportent quelque chose de plus précieux que des conseils : une perspective. Ils sont un rappel qu’une carrière ne se façonne pas uniquement par des résultats, mais aussi par la résilience, la responsabilité et l’exemple donnés aux autres. L’un des objectifs principaux des JOJ est de guider la prochaine génération et les athlètes modèles sont là pour leur montrer la voie. Au ﬁl des pages suivantes, les athlètes modèles de Dakar 2026 reviennent sur leur parcours. Halimah Nakaayi, Blessing Oborududu, Forrester Osei et Jamila Lunkuse se sont entretenus avec Conor Ketley, et Ruth Gbagbi, Jean-Pierre Bourhis et Yves Bourhis avec Salah-Eddine Gakou."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 66-title\" style=\"top:197px;left:44px;\" src=\"/126/static/_content/66-title-1.png\"/>\n      <img class=\"abs halfScale 66-sub\" style=\"top:316px;left:43px;\" src=\"/126/static/_content/66-sub-1.png\"/>      \n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim.fromTo(cOf(\"66-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"66-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg66Anim.stop();\n        }\n      ",
    "searchText": "66  Feature: Dakar 2026 Overview  Championne du monde de course à pied, l’Ougandaise Halimah Nakaayi conﬁe comment sa persévérance, son éducation et l’expérience transformatrice des JOJ ont façonné son parcours jusqu’au sommet.  J  e viens de Kampala, au centre de l’Ouganda – une région dont beaucoup dans le pays pense qu’elle n’engendre pas de grands athlètes. Dans leur esprit, il faut venir des régions montagneuses du pays pour être une grande coureuse. Ma mère était une athlète à l’école, je suis née alors qu’elle n’avait que 17 ans : elle n’a donc pas eu la chance de faire ses preuves. J’ai commencé à courir à l’école à sept ans. J’ai eu la chance que mon établissement permette aux élèves de démontrer leur talent lors de compétitions interscolaires. J’en ai remporté deux, ce qui m’a donné l’opportunité d’aller étudier dans une nouvelle école en internat. Mes parents ne pouvaient pas se  Conor Ketley est un journaliste sportif et reporter basé à Londres (Royaume-Uni). Spécialiste en communications et en mise en récit, il a participé à de nombreuses éditions des Jeux Olympiques. Il a aussi couvert les Jeux Olympiques de la Jeunesse de Lausanne en 2020 et travaille en anglais, français et espagnol.  permettre de payer les frais de scolarité, mais mon père a insisté. « Halimah, regarde notre communauté, regarde notre région, m’a-t-il dit. Nous n’avons jamais eu de grand athlète. La seule manière de t’en sortir dans la vie, c’est d’étudier. J’accepte que tu ailles dans cette école à une condition : que tu saisisses cette opportunité pour t’instruire. »  Briser des barrières Mon père parlait beaucoup des études, mais ma mère m’a aussi beaucoup soutenue. Elle m’accompagnait m’entraîner dans les collines et me proposait des sessions de course supplémentaires. Son soutien m’a beaucoup motivée, mais je me disais : « Je dois étudier. Je dois utiliser ce talent pour me former. » Pendant cette période, je me concentrais sur les cours et je travaillais aussi dur en sport. J’ai eu la chance de franchir toutes les étapes de compétition : les catégories jeunes, juniors et séniors. Mais j’ai également fait preuve de régularité. Durant toutes ces années, je suis restée à l’école et, en 2018, j’ai obtenu ma licence en informatique et technologies de l’information de l’université de Kampala. Ce parcours a été jalonné de sacriﬁces et de travail acharné pour concilier sport et études. Ensuite, j’ai participé aux Championnats du monde d’athlétisme à Doha, en 2019. Personne ne pensait que je pourrais être sacrée championne du monde. J’ai donc le sentiment d’avoir brisé des barrières. En Ouganda,  on a toujours pensé que nous étions doués uniquement sur les longues distances. Pourtant, après ma médaille d’or, de nombreux athlètes ont commencé à briller en demi-fond. Je pense avoir mis un terme à une forme de négativité, ce qui a mené à une transformation en Ouganda. Le chemin a été long, mais ça a été le fruit de la persévérance et de la régularité.  Des souvenirs précieux Quand je pense à Dakar 2026, ça me ramène à mon expérience aux JOJ. J’ai participé à la première édition, Singapour 2010, alors que j’avais seulement 15 ans – et cette expérience a changé ma vie. Vivre dans un village olympique, avec des athlètes de tant de pays différents, découvrir de nouvelles nourritures et boissons… On m’a même offert un smartphone ! Nous n’avions pas de téléphone portable chez nous, à l’époque. Les JOJ m’ont ouvert l’esprit. Ce fut un moment unique qui m’a poussée à travailler encore plus dur pour continuer à représenter l’Ouganda aﬁn de ne pas manquer d’autres rendez-vous extraordinaires comme celui-ci. Depuis cet événement, il ne s’est jamais passé une année sans que je représente mon pays. J’ai désormais l’occasion de parler à la jeune génération, d’être une source d’inspiration. Les JOJ de Dakar inspireront de très nombreux athlètes – pas seulement ceux qui viennent d’Ouganda ou d’Afrique, mais des quatre coins du globe. Le sport offre une plateforme pour lier des personnes venues du monde entier et il ouvre de nouvelles opportunités. La performance est évidemment importante, mais le sport est aussi une bénédiction par la manière dont il nous relie aux autres. ■  1 Halimah Nakaayi a remporté la médaille d’or du 800 m lors des Championnats du monde d’athlétisme à Doha en 2019."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  67  Numéro 126  Halimah Nakaayi est une coureuse de demi-fond ougandaise qui a représenté son pays sur 800 m à trois éditions des Jeux Olympiques : Rio 2016, Tokyo 2020 et Paris 2024. Après avoir vécu sa première expérience olympique aux JOJ de Singapour en 2010, elle a été sacrée championne du monde sur 800 m aux Championnats du monde d’athlétisme de 2019 à Doha. Elle est également membre de la commission des athlètes de World Athletics.  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 68-title\" style=\"top:209px;left:32px;\" src=\"/126/static/_content/68-title-1.png\"/>\n      <img class=\"abs halfScale 68-sub\" style=\"top:330px;left:23px;\" src=\"/126/static/_content/68-sub-1.png\"/>      \n      ",
    "script": "\n        function onPageEnter() {\n          pg68Anim = new TimelineMax();\n          pg68Anim.fromTo(cOf(\"68-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"68-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg68Anim.stop();\n        }\n      ",
    "searchText": "68  Feature: Dakar 2026 Overview  Médaillée d’argent olympique et multiple championne d’Afrique en lutte, Blessing Oborududu se conﬁe sur sa carrière et son désir de voir la prochaine génération aller encore plus loin.  M  on parcours est un chemin pavé de discipline et de dévouement. J’ai toujours eu cette mentalité de ne jamais abandonner, de continuer à me battre et de considérer que, quel que soit le stade de ma carrière, aucun obstacle ne peut m’arrêter. Je peux tout accomplir si j’ai un objectif clair. J’ai commencé la lutte à l’école, pour m’amuser. Mais quand je perdais des compétitions régionales ou nationales, je pleurais. Non pas parce j’avais perdu le tournoi, mais à cause du travail et des efforts pour en arriver là. Parfois, tout ne se passe pas comme prévu, ou vous vous faites surprendre. Mais cette déception m’a fait réaliser que ce désir de réussite était bien ancré en moi.  Tracer sa propre voie Quand j’étais jeune, mon oncle m’a dit que la lutte n’était pas pour les ﬁlles, que c’était réservé aux garçons. Je lui ai répondu : « J’ai vu des lutteuses, alors pourquoi je ne pourrais pas le faire ? » Ces femmes-là étaient des pionnières qui n’avaient pas autant de soutien que nous aujourd’hui. En les découvrant, j’ai eu l’impression que je pouvais être comme elles. J’ai tellement entendu : « Tu es jeune, douée en lutte, mais si tu ne pars pas à l’étranger, tu ne seras jamais une championne. » Je répondais que j’allais rester au Nigeria et réussir.  1 Blessing Oborududu s’impose face à son adversaire en demi-ﬁnale et remporte la médaille d’argent en catégorie 68 kg à Tokyo 2020.  Ma première compétition internationale n’a pas été facile : c’était la première fois que j’affrontais des lutteuses d’autres pays et c’était différent de ce que je connaissais. Aux Championnats d’Afrique, j’ai tout de même remporté la médaille de bronze. Mais à partir de la deuxième compétition, j’ai enchaîné les médailles d’or. Quand j’ai participé à Tokyo 2020, j’avais déjà disputé des Jeux Olympiques, mais ma médaille d’argent a été un moment de joie indescriptible qui restera inscrit dans ma mémoire pour toujours. En repensant à d’où je viens – toutes les épreuves que j’ai dû surmonter, tout le travail que j’ai dû fournir – je réalise à quel point ce moment était incroyable. Atteindre la ﬁnale, c’était un rêve qui se réalisait. C’est un privilège de remporter des médailles pour mon pays dans le sport de haut niveau.  me voir pour me dire : « J’ai suivi ton conseil et ça a marché ! » J’espère pouvoir faire la même chose pour Dakar 2026. Et même s’ils ne gagnent pas aux JOJ, ils connaîtront certainement le succès, avec le temps. Ce premier événement olympique organisé en Afrique est un moment réellement à part. Ça signiﬁe que le continent grandit et que nous avons davantage d’opportunités de mettre en valeur nos jeunes talents et notre culture sur la scène internationale. ■  Élever les autres encore plus haut Depuis que je suis jeune, j’ai toujours encouragé les autres. J’aime les voir progresser, ce qui rend mon rôle d’entraîneure naturel aujourd’hui. J’ai toujours la passion d’une athlète et je veux voir d’autres générations faire encore mieux que moi. J’ai remporté une médaille d’argent aux Jeux, mais maintenant je veux voir mes successeurs gagner l’or. Il est important pour les jeunes d’avoir des mentors et c’est un privilège pour moi de pouvoir endosser ce rôle et d’être une source d’inspiration pour eux. Quand je travaille avec des athlètes, mon plus grand bonheur, c’est quand ils viennent  Blessing Oborududu est une lutteuse nigériane avec l’un des plus beaux palmarès africains dans ce sport. Sacrée 14 fois championne d’Afrique, elle a écrit une page d’histoire à Tokyo 2020 en devenant la première lutteuse nigériane à remporter une médaille olympique, en se parant d’argent dans la catégorie 68 kg. Elle a représenté le Nigeria à quatre éditions des Jeux : Londres 2012, Rio 2016, Tokyo 2020 et Paris 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 70-title\" style=\"top:243px;left:44px;\" src=\"/126/static/_content/70-title-1.png\"/>\n      <img class=\"abs halfScale 70-sub\" style=\"top:316px;left:43px;\" src=\"/126/static/_content/70-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.fromTo(cOf(\"70-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"70-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg70Anim.stop();\n        }\n      ",
    "searchText": "70  Feature: Dakar 2026 Overview  L’haltérophile ghanéen Forrester Osei se conﬁe sur le rôle central des modèles, l’importance du soutien et pourquoi les Jeux Olympiques de la Jeunesse (JOJ) de Dakar 2026 représentent un moment pivot pour les jeunes athlètes.  J  ’ai grandi dans une grande famille. Mes frères et cousins étaient tout le temps dans les parages et nous faisions beaucoup de sport ensemble. L’un de mes frères m’a particulièrement poussé : c’est lui qui m’a amené à la salle de sport pour la première fois et qui m’a dit que j’avais la force et le talent pour pouvoir concrétiser mes rêves. Il était très respecté dans notre communauté, par les jeunes comme par les anciens. Je pense que toute la famille considérait qu’il avait réussi car il incarnait toutes les valeurs qui nous tenaient à cœur. Il a tracé un chemin pour moi, pour que je réalise que je pouvais tout accomplir. L’avoir comme modèle, ça m’a ﬁxé un cap que j’ai toujours suivi. J’estime qu’il est primordial pour les jeunes d’aujourd’hui d’avoir des modèles positifs, des personnes qu’ils peuvent considérer comme des références pour se jauger, savoir s’ils sont sur la bonne voie et se dire qu’ils peuvent viser encore plus haut.  L’importance de Dakar 2026 Dakar 2026 est un événement historique qui se déroule sur le continent de ma terre d’origine. Dès que j’ai entendu parler des athlètes modèles pour les JOJ, j’ai immédiatement cherché à en faire partie. Je veux apporter ma contribution pour que cet événement soit un succès pour les jeunes athlètes qui y participeront. L’haltérophilie ne ﬁgure pas au programme des compétitions pour les JOJ, mais nous  proposerons des démonstrations. Si un ou une jeune vient regarder et se sent inspiré à pratiquer ce sport, héritier d’une longue tradition en Afrique, alors ce sera un grand succès pour moi. Car c’est ça qui importe : encourager d’autres à faire quelque chose dont ils ne se seraient jamais crus capables. Peu importe ce qui se passera à Dakar, j’en repartirai le cœur comblé, en sachant qu’une personne que j’ai croisée se souviendra peut-être de notre rencontre, même brève. Savoir que je peux apporter quelque chose de positif dans la vie de quelqu’un d’autre est très important pour moi.  Aucun athlète ne peut réussir seul Quand j’étais jeune, j’ai beaucoup joué au football, qui nécessite une bonne condition physique, ce qui a créé un environnement parfait pour ma transition vers l’haltérophilie. Par la suite, je me suis qualiﬁé pour les Championnats du monde d’haltérophilie, puis pour les Jeux africains à Brazzaville, avant de remporter une médaille d’or aux Championnats d’haltérophilie du Commonwealth 2016. Quand je repense à ma carrière, le premier mot qui me vient, c’est la gratitude. Je suis reconnaissant et heureux de mes succès. Alors bien sûr, il me reste d’autres objectifs, notamment les Jeux de Los Angeles 2028, pour lesquels je vais essayer de me qualiﬁer. Mais cette gratitude vient du fait d’être heureux de ma carrière et d’avoir été entouré des bonnes personnes durant mon parcours.  Avoir un entourage qui vous soutient, c’est un élément clé dans le parcours de n’importe quel athlète. Les personnes extérieures au sport ne mesurent pas toujours combien c’est primordial. Elles nous aident sur le plan psychologique en dehors de l’entraînement et contribuent à entretenir notre motivation. Parfois, votre parcours sportif peut être semé d’embûches : ne pas savoir si l’on va gagner, craindre de décevoir ceux qui nous soutiennent. Être bien entouré, c’est bon pour le moral – ça vous enlève un poids. J’ai désormais la possibilité de m’impliquer auprès de jeunes athlètes à Dakar 2026, d’apporter ma contribution à différents niveaux. Alors que les JOJ seront un événement historique en Afrique, c’est le bon moment pour m’engager et aider à façonner la prochaine génération. ■  1 Forrester Osei estime que Dakar 2026 pourrait marquer un tournant pour le sport en Afrique."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "L’haltérophile ghanéen Forrester Osei a représenté son pays dans des compétitions internationales majeures, telles que les Jeux du Commonwealth et de multiples Championnats du monde. Il a remporté l’or dans la catégorie des 94 kg aux Championnats du Commonwealth à Penang (Malaisie) en 2016. Il joue aussi un rôle important au sein de la Fédération internationale d’haltérophilie (IWF) en tant que président de la commission des athlètes de l’IWF.  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 72-title\" style=\"top:259px;left:44px;\" src=\"/126/static/_content/72-title-1.png\"/>\n      <img class=\"abs halfScale 72-sub\" style=\"top:330px;left:43px;\" src=\"/126/static/_content/72-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg72Anim = new TimelineMax();\n          pg72Anim.fromTo(cOf(\"72-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"72-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg72Anim.stop();\n        }\n      ",
    "searchText": "72  Feature: Dakar 2026 Overview  Des premières amitiés à la piscine jusqu’à la scène olympique, l’histoire de Jamila Lunkuse montre que le plaisir du sport compte autant que les résultats.  M  on parcours a commencé à Kampala, en Ouganda. J’étais une enfant très sportive : je me suis essayée à des tas de sports à l’école (badminton, basketball, football), mais c’est la natation qui est restée. Ce sont surtout mes amis qui m’y ont attirée. Au départ, c’était juste une excuse pour sortir de l’école. On faisait tous partie du même club et on allait aux compétitions ensemble. En grandissant, les entraînements étaient plus longs et plus durs, mais vivre ça ensemble, ça a renforcé nos liens d’amitié.  De nouveaux horizons À 12 ans, j’ai déménagé au Royaume-Uni pour étudier au collège de Plymouth. C’est là que la natation a pris une autre dimension dans ma vie et que j’ai affiné ma technique. J’étais en internat uniquement avec d’autres nageurs : j’ai adoré cette expérience. À 15 ans, j’ai disputé mes premiers Jeux Olympiques, à Londres 2012. Je me suis tellement amusée ! Après ma course, je me souviens avoir juste tenté de savourer, d’échanger autant de pin’s que possible et de me mêler aux athlètes de différents pays. Mais en vérité, j’étais tellement jeune que je ne pense pas avoir réalisé à quel point c’était un jalon dans ma carrière. Ma philosophie, c’était de me dire : « OK, ça, c’est fait, et maintenant ? Je peux faire mieux. » Je n’ai pas pris le temps d’apprécier ce que j’avais accompli. C’est seulement après avoir participé à Rio 2016 que j’ai commencé à comprendre le chemin que j’avais parcouru. Quand j’entendais  parler d’athlètes qui disputaient leurs deuxièmes Jeux, je me disais : « Ah oui, moi aussi j’y ai participé ! » J’ai enﬁn réalisé que j’avais accompli beaucoup de choses dans ma vie.  « S’ils peuvent le faire, alors toi aussi » En grandissant, je n’avais pas vraiment de modèles en natation. Je ne sais pas si c’est en raison de l’absence de nageuses qui me ressemblaient. Les sportives que j’admirais, c’était surtout en athlétisme, comme Shelly-Ann Fraser-Pryce et Allyson Felix. J’adorais la conﬁance qu’elles dégageaient et le plaisir qu’elles prenaient sur la piste. J’admirais aussi Dorcus Inzikuru, la coureuse ougandaise spécialiste de steeple, car elle rayonnait de bonheur : avant la course, elle souriait, et après la course, elle souriait. Quand tu te reconnais dans quelqu’un ou que tu vois une personne qui te ressemble accomplir de grandes choses, ça te donne de l’espoir et de la conﬁance. S’ils peuvent le faire, alors toi aussi tu en es capable. Ça a été très important pour moi.  Réussir en tant qu’athlète modèle Le but des Jeux Olympiques de la Jeunesse est de rassembler de jeunes athlètes du monde entier et d’encourager la pratique sportive. Je pense qu’ils ont aussi besoin de modèles qui représentent la diversité, car chacun vient d’horizons différents, avec ses propres expériences et son vécu à partager. Chaque athlète veut être médaillé olympique – c’est  l’objectif ! – mais tous n’y parviendront pas. Ça ne veut pas dire que ton histoire n’a pas de valeur ou que le sport ne t’a pas offert des opportunités incroyables. À Dakar 2026, je veux simplement être présente et aussi accessible que possible. Je n’aurai pas la réponse à toutes les questions, mais si je parviens à inspirer ou soutenir un seul athlète pour qu’il continue sur sa voie ou se sente moins seul dans son parcours, ce sera un grand succès pour moi. Quand tu es une jeune athlète, tu peux vivre des choses difficiles et penser que tu es la seule dans ce cas. Être une athlète modèle vous met dans une position privilégiée pour partager votre histoire et la manière dont vous avez géré certaines situations – et ça peut faire la différence pour quelqu’un qui éprouve des difficultés en silence. Ces jeunes athlètes méritent de comprendre l’ampleur de leurs accomplissements. Être sélectionné pour représenter son pays signiﬁe que vous faites partie de la crème de la crème : ils peuvent en être ﬁers. Mais le plus important, c’est de savourer cette expérience : se faire des amis, échanger des pin’s et proﬁter de chaque instant ! Ils conserveront toute leur vie le souvenir de ces JOJ. ■  1 Jamila Lunkuse souhaite que les jeunes athlètes aient conscience de tout ce que le sport peut leur apporter."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  73  Numéro 126  Jamila Lunkuse a représenté l’Ouganda aux Jeux Olympiques de Londres 2012 et Rio 2016, ainsi qu’à deux éditions des Jeux du Commonwealth. Elle a établi de nombreux records nationaux et a remporté des médailles de bronze au 50 m et au 100 m brasse lors des Jeux africains de la jeunesse de 2010 à Rabat (Maroc). Au-delà de sa carrière sportive, elle est aussi membre de la commission des athlètes de World Aquatics.  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 74-title\" style=\"top:208px;left:29px;\" src=\"/126/static/_content/74-title-1.png\"/>\n      <img class=\"abs halfScale 74-sub\" style=\"top:333px;left:43px;\" src=\"/126/static/_content/74-sub-1.png\"/>  \n      ",
    "script": "\n        function onPageEnter() {\n          pg74Anim = new TimelineMax();\n          pg74Anim.fromTo(cOf(\"74-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"74-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg74Anim.stop();\n        }\n      ",
    "searchText": "74  Feature: Dakar 2026 Overview  Ruth Gbagbi – championne ivoirienne de taekwondo, médaillée olympique et désormais athlète modèle pour Dakar 2026 – voit dans cet événement une source de ﬁerté pour le continent et une occasion de transmettre aux jeunes générations.  Les Jeux Olympiques de la Jeunesse (JOJ) de Dakar 2026 seront le premier événement olympique organisé en Afrique. Qu’est-ce que cela représente pour vous ? C’est avant tout une grande ﬁerté. Pour moi, pour les athlètes africains et plus largement pour tout le continent. C’est aussi un moment très fort, parce que j’ai moi-même participé aux JOJ à Singapour en 2010. Je sais ce que ça représente pour un jeune athlète : les  Salah-Eddine Gakou est un journaliste présentateur franco-sénégalais. Il collabore notamment avec TV5 MONDE. Il intervient également en modération d’événements et en école de journalisme, où il enseigne la radio. Depuis plus de 10 ans, il couvre des sujets liés à l’actualité internationale, au sport et à la jeunesse, entre l’Afrique et la France.  rencontres, les échanges et tout ce qu’on apprend en dehors de la compétition. Je pense que Dakar 2026 peut être un véritable tournant. On a déjà vu que l’Afrique est capable d’organiser de grands événements, notamment récemment avec la Coupe d’Afrique des Nations. Ces Jeux vont montrer ce dont le continent est capable.  Au-delà des médailles, qu’est-ce que votre carrière vous a appris ? L’humilité et la rigueur, avant tout. Ce sont des valeurs essentielles, dans le sport comme dans la vie. J’ai eu la chance d’être entourée de personnes qui m’ont beaucoup appris et donné des conseils importants. J’ai envie à mon tour de transmettre aux jeunes générations.  Pensez-vous que cela puisse ouvrir la voie à l’organisation de Jeux Olympiques en Afrique ? Oui, je le pense. Ce type d’événement peut faire évoluer les mentalités, changer le regard et donner conﬁance. Dakar 2026 peut être une étape importante dans cette évolution.  Quel regard portez-vous sur la jeunesse africaine aujourd’hui ? Je pense que la jeunesse africaine est extrêmement ambitieuse et créative. On le voit dans le sport, mais aussi dans la musique, l’art ou sur les réseaux sociaux. Il y a une vraie énergie et une volonté de réussir, parfois directement sur le continent africain, pour porter les couleurs de l’Afrique.  Vous serez athlète modèle. Quel rôle souhaitez-vous jouer auprès des jeunes ? J’ai envie de partager mon expérience et surtout les encourager à proﬁter de cette occasion. Les JOJ, ce n’est pas seulement la compétition : il y a aussi tout ce que le CIO met en place autour, en termes de rencontres, de formations et d’échanges. Ce sont des expériences qui peuvent marquer un parcours. Quand vous aviez leur âge, comment vous projetiez-vous dans l’avenir ? J’ai commencé le sport assez jeune et, dès l’âge de 10 ans, j’étais déjà très concentrée sur la pratique sportive. Très tôt, j’ai eu envie d’aller loin et de progresser. Mais à cet âge-là, on ne mesure pas forcément tout ce qui peut arriver dans une carrière.  En dehors du sport, qu’avez-vous envie de découvrir à Dakar ? J’ai envie de vivre toutes les expériences possibles à Dakar. Que ce soit manger le meilleur thieboudiene préparé par une maman sénégalaise, visiter des lieux, découvrir la culture sénégalaise, mais aussi danser (notamment le mbalax). D’habitude, quand je vais au Sénégal, c’est dans le cadre de compétitions. Cette fois, ce ne sera pas le cas, donc j’ai envie de me lâcher un peu plus et je suis ouverte à toutes les découvertes. ■ 1 Ruth Gbagbi a remporté le bronze à Rio 2016 et à Tokyo 2020 dans la catégorie des -67 kg en taekwondo."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  75  Numéro 126  1  La taekwondoïste ivoirienne Ruth Gbagbi est entrée dans l’histoire en remportant la toute première médaille olympique féminine de la Côte d’Ivoire. Elle a décroché le bronze dans la catégorie des -67 kg aux Jeux de Rio en 2016. Elle a ensuite participé aux Jeux de Tokyo 2020, où elle a remporté une autre médaille de bronze dans la même catégorie. Elle est aussi multiple championne d'Afrique et a été sacrée lors des Championnats du monde de taekwondo de 2017 à Muju (Corée du Sud), dans la catégorie des -62 kg."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 76-title\" style=\"top:197px;left:21px;\" src=\"/126/static/_content/76-title-1.png\"/>\n      <img class=\"abs halfScale 76-sub\" style=\"top:320px;left:43px;\" src=\"/126/static/_content/76-sub-1.png\"/>      \n      ",
    "script": "\n        function onPageEnter() {\n          pg76Anim = new TimelineMax();\n          pg76Anim.fromTo(cOf(\"76-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"76-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg76Anim.stop();\n        }\n      ",
    "searchText": "76  Feature: Dakar 2026 Overview  Frères, franco-sénégalais, olympiens. Jean-Pierre et Yves Bourhis partagent le même sport, la même discipline et bientôt le même rôle : celui de transmettre. Désignés athlètes modèles de Dakar 2026, les deux kayakistes se conﬁent notamment sur la ﬁerté, la résilience et le Sénégal.  Dakar 2026, les Jeux Olympiques de la Jeunesse (JOJ) sur le continent africain, qu'est-ce que ça représente ? Jean-Pierre : C’est la première pierre d’un édiﬁce et que ce soit au Sénégal, notre pays, c’est une grande ﬁerté. Les jeunes qu’on va rencontrer, je pense qu’on les reverra plus tard lors des Jeux Olympiques. On espère les voir briller. Yves : On a tous les deux participé aux Jeux Olympiques. On n’a pas eu la chance de participer aux JOJ, mais être acteurs de cet événement d’une autre manière, c’est quand même une grande ﬁerté. Ça va être une grande fête ! Vous serez des athlètes modèles : quel rôle avez-vous envie de jouer auprès des jeunes athlètes ? Jean-Pierre : J’aimerais inspirer sur deux fronts : être olympien, mais aussi montrer que ces athlètes peuvent faire des études, concilier le sport et une vie professionnelle. Moi je travaille un peu trop, il faudrait que je travaille un peu moins pour être un peu plus performant. Mais je vois trop d’athlètes renoncer parce que les ﬁnancements ne sont pas là, surtout en Afrique. Il faut trouver des alternatives, travailler à mi-temps, s’autoﬁnancer. Il y a vraiment une voie possible. Yves : Moi j’aimerais leur transmettre la résilience. Échouer, ça fait partie du processus.  Je suis aussi d’accord avec Jean-Pierre sur le fait d’avoir un métier. Aux derniers Jeux, j’étais le seul parmi les ﬁnalistes à avoir un emploi. Ce n’est pas facile, mais c’est possible de tout faire en même temps. Être frères dans la même discipline, qu’est-ce que ça change ? Jean-Pierre : On fait les déplacements, les compétitions et les stages ensemble. On s’encourage quand l’un passe à l’étape d’après, on se pousse. En compétition, le meilleur gagne et puis voilà. On met les egos de côté. Yves : On se connaît bien, on fonctionne pareil. Et quand on ne s’affronte pas sur les mêmes épreuves, on s’analyse, on se donne des retours sur le bassin. Sans ça, ce serait beaucoup plus compliqué. Le canoë slalom reste assez méconnu du grand public. Qu’aimeriez-vous que les gens comprennent de votre discipline ? Jean-Pierre : Que quand on rentre dans ce cercle, il est plutôt sympa. En course, on se connaît tous, on se dit bonjour. Ce n’est pas la même rivalité que dans le foot ou le tennis. On fait du sport, on est là pour le plaisir en premier. Et ce sport permet de voir le monde, de découvrir des endroits sympas. Les JOJ vont en donner un bel échantillon. Yves : En s’ouvrant, notre sport peut devenir de plus en plus connu. On peut facilement  rencontrer les champions, leur parler. Tout le monde est accessible. Si je vous dis Dakar, vous pensez à quoi en premier ? Jean-Pierre : À tout faire au maximum. Je n’y suis pas retourné depuis 2016. On a de la famille du côté de notre mère, tristement décédée il y a quelques années. On va essayer de reprendre le lien avec nos cousins, manger les plats locaux, ça c’est une évidence. Et puis il y a un projet que je mène avec une association qui fabrique du matériel en composite : des tables pour les écoles, une pirogue, un kayak slalom produit localement. Des projets qui ont un vrai impact local. Yves : La première chose que je vais faire, c’est un bon petit repas. Un yassa ou un mafé. J’étais au Sénégal durant deux semaines l’été dernier, donc je sais exactement ce qui me manque. Et puis une balade pour découvrir les sites des épreuves… ■  1 Yves Bourhis termine sa descente lors de l’épreuve de slalom K1 aux Jeux de Paris 2024. 2 Jean-Pierre Bourhis s’est classé 18e lors de l’épreuve de slalom C1 aux Jeux de Rio 2016."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  2  Jean-Pierre et Yves Bourhis sont deux frères francosénégalais, athlètes de canoë slalom, qui ont tous deux représenté le Sénégal aux Jeux Olympiques. Jean-Pierre a participé à Rio 2016 et Tokyo 2020, tandis qu’Yves a représenté son pays à Paris 2024.  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 78-title\" style=\"top:76px;left:43px;\" src=\"/126/static/_content/78-title-1.png\"/>\n      <img class=\"abs halfScale 78-sub\" style=\"top:145px;left:43px;\" src=\"/126/static/_content/78-sub-1.png\"/>\n\n      <div class=\"addContentLink\" style=\"top:824px;left:172px;width:142px;height:12px\">\n        <a href=\"mailto:studies.centre@olympic.org\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:824px;left:320px;width:115px;height:12px\">\n        <a href=\"https://olympics.com/studies\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:824px;left:440px;width:110px;height:12px\">\n        <a href=\"https://olympics.com/library\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:836px;left:184px;width:115px;height:12px\">\n        <a href=\"https://www.facebook.com/OlympicStudiesCentre/?locale=en_GB\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:836px;left:304px;width:231px;height:12px\">\n        <a href=\"https://www.linkedin.com/showcase/olympic-studies-centre/?originalSubdomain=ch\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:342px;left:44px;width:169px;height:15px;\">  \n        <a href=\"https://library.olympics.com/Default/detailstatic.aspx?RSC_BASE=SYRACUSE&RSC_DOCID=3857000&TITLE=let-s-get-moving-together-a-toolkit-for-grassroots-sport-leaders-international-council-of-sport-scie&_lg=fr-FR\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:342px;left:259px;width:179px;height:15px;\">  \n        <a href=\"https://library.olympics.com/Default/detailstatic.aspx?RSC_BASE=SYRACUSE&RSC_DOCID=3788749&TITLE=fast-tracks-and-dark-deals-how-sport-became-business-and-business-became-sport-michael-payne&_lg=fr-FR\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:342px;left:475px;width:112px;height:15px;\">  \n        <a href=\"https://library.olympics.com/Default/detailstatic.aspx?RSC_BASE=SYRACUSE&RSC_DOCID=3704609&TITLE=a-games-changer-the-international-olympic-committee-tokyo-2020-and-covid-19-stephen-r-wenn-and-rober&_lg=fr-FR\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.fromTo(cOf(\"78-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"78-sub\"), 0.9, {opacity:0, y:15}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "78  Centre d’Études Olympiques  CENTRE D’ÉTUDES OLYMPiQUES Les dernières parutions recensées par le Centre d’Études Olympiques du CIO, votre source de connaissances olympiques.  LET’S GET MOVING TOGETHER!  FAST TRACKS AND DARK DEALS  A GAMES CHANGER  Cette deuxième édition de la boîte à outils du Conseil international pour l’éducation physique et la science du sport (CIEPSS) propose des conseils pour les professionnels, les éducateurs et les ONG travaillant dans le sport de masse et le sport au service du développement, sur la manière de concevoir, gérer et évaluer des programmes communautaires. Mis à jour par des leaders du sport provenant de Namibie, d’Afrique du Sud et de Zambie, il reﬂète les conditions sur le terrain et offre une perspective africaine sur le leadership, l’inclusion, la gouvernance et la livraison de programmes. S’appuyant sur leur expérience en matière d’entraînement, d’enseignement, de leadership communautaire et de recherche, les auteurs proposent des ressources à même de répondre aux déﬁs opérationnels du secteur. Cet ouvrage couvre des thèmes tels l’autonomisation, le leadership, la gouvernance et la gestion organisationnelle, l’égalité et l’inclusion, le développement de partenariats, les levées de fonds et la viabilité à long terme.  Dans cette autobiographie, Michael R. Payne – l’une des ﬁgures les plus inﬂuentes du marketing sportif contemporain et ancien directeur marketing du CIO – offre un regard inédit sur l’avèment du sport mondial en force économique majeure. S’appuyant sur 50 ans passés au cœur du Mouvement olympique puis de la Formule 1, il mêle son expérience personnelle à une analyse incisive des forces politiques, commerciales et stratégiques qui ont transformé le sport international. Michael Payne retrace la création du programme des partenaires olympiques (TOP), la réinvention des droits de diffusion mondiaux et des partenariats commerciaux qui ont assuré la stabilité des Jeux Olympiques sur le long terme. Ce récit, raconté d’un point de vue « assez proche pour entendre les bruits de couloirs, mais suffisamment distant pour voir émerger les schémas globaux », propose une vision rare et se conclut par une prédiction pour les cinq décennies à venir.  Stephen R. Wenn et Robert K. Barney explorent un moment charnière de l’histoire olympique : le report des Jeux de Tokyo 2020. À travers de nombreuses sources, dont la couverture médiatique et des entretiens avec des officiels du CIO, ils révèlent les coulisses du processus de prise de décisions durant la COVID-19. Face aux risques sanitaires, aux pressions politiques, aux enjeux économiques et aux déﬁs logistiques, le premier ministre japonais Abe Shinzo et le président du CIO Thomas Bach ont fait le choix sans précédent de reporter les Jeux, plutôt que de les annuler. Plus qu’une chronique, cet ouvrage propose une réﬂexion sur la manière dont le Mouvement olympique peut s’adapter aux déﬁs mondiaux. À lire par toutes les personnes intéressées par la gouvernance sportive, la gestion de crise et l’esprit intemporel des Jeux.  A TOOLKIT FOR GRASSROOTS SPORT LEADERS  HOW SPORT BECAME BUSINESS AND BUSINESS BECAME SPORT  PUBLiÉ PAR : CIEPSS, 2025, 88 pages,  ÉCRiT PAR : Michael R. Payne PUBLiÉ PAR : Chiselbury Publishing, 2025,  en anglais.  9781916556751, 585 pages, en anglais.  THE INTERNATIONAL OLYMPIC COMMITTEE, TOKYO 2020 & COVID-19  ÉCRiT PAR : Stephen R. Wenn, Robert K. Barney. PUBLiÉ PAR : The University of Arkansas Press, 2025, 9781682262764, 258 pages, en anglais.  POUR EN SAVOIR PLUS Pour des informations historiques et factuelles ainsi que des recherches, des ressources documentaires ou des informations sur notre réseau et nos programmes académiques, contactez-nous et consultez Olympic World Library. studies.centre@olympic.org olympics.com/etudes olympics.com/library OlympicStudiesCentre linkedin.com/showcase/olympic-studies-centre"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Zero distractions when it matters the most Through seamless technology integration, we’re helping the IOC keep the spotlight where it belongs—on the athletes.  Nour Elhouda Ettaieb OLY Rowing, Tunisia Consultant, Deloitte US Nanjing 2014; Rio 2016; Tokyo 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 80-title\" style=\"top:97px;left:43px;\" src=\"/126/static/_content/80-title-1.png\"/>\n      <img class=\"abs halfScale 80-sub\" style=\"top:165px;left:43px;\" src=\"/126/static/_content/80-sub-1.png\"/>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg80Anim = new TimelineMax();\n          pg80Anim.fromTo(cOf(\"80-title\"), 0.9, {opacity:0, x:35}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)\n          .fromTo(cOf(\"80-sub\"), 0.9, {opacity:0, y:10}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3);\n        }\n\n        function onPageLeave() {\n          pg80Anim.stop();\n        }\n      ",
    "searchText": "80  Décès  DÉCÈS  Nous rendons hommage aux athlètes olympiques et personnalités du Mouvement olympique qui nous ont quittés.  SiR CRAiG REEDiE Ancien vice-président du CIO qui a joué un rôle clé dans la lutte contre le dopage.  MELiTÓN SÁNCHEZ RiVAS  Membre honoraire du CIO et éminent dirigeant du sport international, Sir Craig Reedie nous a quittés à l’âge de 84 ans. Ancien joueur international de badminton, il a ensuite occupé un rôle central au sein du Mouvement olympique : président du Comité National Olympique britannique de 1992 à 2005 et membre du CIO à partir de 1994, il a été vice-président de l’institution entre 2012 et 2016. Sir Craig Reedie a joué un rôle clé pour inclure le badminton dans le programme olympique de Barcelone 1992 et s’est grandement engagé dans la candidature victorieuse de Londres 2012. Il a également dirigé l’Agence Mondiale Antidopage de 2014 à 2019 et a été décoré de l’Ordre olympique en 2023 pour les services qu’il a rendus au sport.  Membre honoraire du CIO et personnalité inﬂuente du sport panaméen et des Amériques, Melitón Sánchez Rivas est décédé à 91 ans. Après une carrière dans le baseball et le softball, il a ensuite embrassé le rôle de dirigeant sportif, notamment au sein du CNO du Panama, dont il a été trésorier puis président entre 1982 et 2007. Membre du CIO entre 1998 et 2014, il en a ensuite été nommé membre honoraire. Il a été décoré de l’Ordre olympique en 2014 pour saluer sa contribution au Mouvement olympique.  WiLLiAM THORESSON  STEVE CLARK  Champion olympique suédois de gymnastique, William Thoresson nous a quittés à 93 ans. Titré au sol à Helsinki 1952, il est devenu le premier athlète suédois – et le seul à ce jour – à remporter l’or en gymnastique, avant d’obtenir l’argent dans la même épreuve à Melbourne 1956. William Thoresson a participé à quatre éditions des Jeux entre 1952 et 1964 et a remporté le bronze au sol aux Championnats du monde de 1954. Il a intégré le Panthéon international de la gymnastique en 2001 pour sa contribution à son sport.  Triple champion olympique en natation avec les États-Unis, Steve Clark nous a quittés à 82 ans. Spécialiste de la nage libre, il a participé à Rome 1960 avant de remporter trois médailles d’or à Tokyo 1964, dans les relais 4 × 100 m nage libre, 4 × 200 m nage libre et 4 × 100 m quatre nages. Chacun de ces sacres a donné lieu à un record du monde. Steve Clark a aussi remporté l’or dans le 100 m nage libre aux Jeux Panaméricains de 1963. Il a été nommé au Panthéon international de la natation en 1966.  MARiAN KASPRZYK Boxeur polonais médaillé d’or olympique, Marian Kasprzyk est décédé à 86 ans. Il a remporté l’or en poids mi-moyen à Tokyo 1964, après avoir décroché le bronze en poids super-légers à Rome 1960. Marian Kasprzyk a également participé aux Jeux de Mexico 1968."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  81  Numéro 126  RAJA RANDHiR SiNGH  UNG CHANG  Raja Randhir Singh, quintuple olympien et membre honoraire du CIO, est décédé à l’âge de 79 ans. Tireur sportif (fosse et skeet), il a représenté l’Inde lors de cinq éditions des Jeux Olympiques, de Mexico 1968 à Los Angeles 1984. Élu membre du CIO en 2001, il a exercé cette fonction jusqu’en 2014, avant d’être nommé membre honoraire. Raja Randhir Singh a également occupé pendant près de trois décennies le poste de secrétaire général de l’Association olympique indienne, contribuant à façonner le sport indien aux niveaux national et international.  Membre honoraire du CIO engagé dans la diplomatie pour promouvoir le dialogue à travers le sport. Le professeur Ung Chang, membre honoraire du CIO et ﬁgure de proue du sport dans la péninsule coréenne, est décédé à 87 ans. Ancien capitaine de l’équipe de basketball de la République populaire démocratique de Corée (RPDC), il a ensuite consacré sa carrière à l’administration sportive. Secrétaire général puis vice-président du CNO de la RPDC, il a également été vice-président du Conseil olympique d’Asie. Élu membre du CIO en 1996, Ung Chang est devenu l’unique représentant de son pays dans l’organisation, dont il a plus tard été nommé membre honoraire. Fervent partisan du dialogue à travers le sport, il a contribué à l’historique déﬁlé conjoint entre les délégations de la RPDC et de la République de Corée lors des cérémonies d’ouverture de Sydney 2000 et PyeongChang 2018.  FRANCO MENiCHELLi Quintuple médaillé olympique italien, le gymnaste Franco Menichelli est décédé à 84 ans. Il avait remporté la médaille d’or au sol à Tokyo 1964, où il avait aussi décroché l’argent aux anneaux et le bronze aux barres parallèles. Ce palmarès s’ajoute aux deux médailles de bronze qu’il avait obtenues à Rome en 1960, dans l’épreuve par équipe et au sol. Pionnier des ﬁgures modernes au sol, il a remporté six titres européens, dont le titre du concours général en 1965, et trois médailles de bronze aux Championnats du monde. Il a ensuite entraîné l’équipe nationale masculine d’Italie.  DAViNDER SiNGH GARCHA Hockeyeur olympique médaillé d’or avec l’Inde, Davinder Singh Garcha nous a quittésà 73 ans. Membre de l’équipe indienne qui a remporté l’or à Moscou 1980, il avait inscrit huit buts en six matches pour aider sa nationà remporter un huitième titre olympique consécutif en hockey sur gazon masculin – un record – en battant l’Espagne 4-3 en ﬁnale.  RONNiE DELANY Ronnie Delany, médaillé d’or olympique irlandais en athlétisme, est décédé à 91 ans. Il a été sacré sur 1 500 m à Melbourne 1956, avec un sprint ﬁnal qui lui a permis de battre le record olympique. Il est ainsi devenu le premier Irlandais médaillé d’or olympique en athlétisme depuis 1932. Ronnie Delany a remporté le bronze sur 1 500 m aux Championnats d’Europe d’athlétisme en 1958 et a aussi participé aux Jeux de Rome 1960.  MARY RAND Première championne olympique de Grande-Bretagne en athlétisme, Mary Rand nous a quittés à 86 ans. Elle avait écrit une page d’histoire à Tokyo 1964, en remportant la médaille d’or du saut en longueur féminin avec un bond à 6,76 m, battant le record du monde. Première femme britannique sacrée aux Jeux en athlétisme, elle s’est aussi parée d’argent en pentathlon et de bronze en relais 4 × 100 m pour devenir la première athlète de son pays à décrocher trois médailles lors d’une même édition des Jeux."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 82-title\" style=\"top:76px;left:45px;\" src=\"/126/static/_content/82-title-1.png\"/>\n      <img class=\"abs halfScale 82-sub\" style=\"top:162px;left:43px;\" src=\"/126/static/_content/82-sub-1.png\"/>\n\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:258px;left:106px; font-size: 7.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 1}' ></h1>  \n      <img class=\"abs halfScale 82-title\" style=\"top:279px;left:133px;\" src=\"/126/static/_content/82-text-1.png\"/>\n\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:463px;left:137px; font-size: 4.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 50}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:612px;left:190px; font-size: 4.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 4}' ></h1>\n\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:250px;left:469px; font-size: 4.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 14}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:353px;left:499px; font-size: 4.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 153}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:481px;left:399px; font-size: 4.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 2700, \"comma\" : true}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:469px;left:609px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 5000, \"comma\" : true}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:508px;left:541px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 200}' ></h1>\n\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:640px;left:512px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 263}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:640px;left:585px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 29}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:691px;left:341px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 900000, \"comma\" : true}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:746px;left:333px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 11000, \"comma\" : true}' ></h1>\n\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:757px;left:445px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 3, \"comma\" : true}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:801px;left:497px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 8, \"comma\" : true}' ></h1>\n      <h1 id=\"82-no\" class=\"abs olympicHeadlineCon 82-no\" style=\"top:816px;left:574px; font-size: 2.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\" data-number='{\"to\": 1, \"comma\" : true}' ></h1>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.staggerFromTo(cOf(\"82-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.5, 1)\n          .fromTo(cOf(\"82-sub\"), 0.9, {opacity:0, y:25}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3)\n          .fromTo(cOf(\"82-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[0])}}, 1.3)\n          .fromTo(cOf(\"82-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[1])}}, 1.3)\n          .fromTo(cOf(\"82-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[2])}}, 1.3)\n          .fromTo(cOf(\"82-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[3])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[4])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[5])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[6])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[7])}}, 1.5)\n          .fromTo(cOf(\"82-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[8])}}, 1.7)\n          .fromTo(cOf(\"82-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[9])}}, 1.7)\n          .fromTo(cOf(\"82-no\")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[10])}}, 1.7)\n          .fromTo(cOf(\"82-no\")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[11])}}, 1.7)\n          .fromTo(cOf(\"82-no\")[12], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[12])}}, 1.9)\n          .fromTo(cOf(\"82-no\")[13], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[13])}}, 1.9)\n          .fromTo(cOf(\"82-no\")[14], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[14])}}, 1.9)\n        }\n\n        function onPageLeave() {\n          pg82Anim.stop();\n          resetNumbers(\"82-no\");\n        }\n      ",
    "searchText": "82  Le mot de la ﬁn  L’ÉLAN DE LA JEUNESSE La Revue Olympique fait une analyse en chiffres de la quatrième édition des Jeux Olympiques de la Jeunesse d’été.  1  14 153  ÈRE  jours de compétition 31 octobre – 13 novembre 2026 25 sports de compétition 10 sports d’engagement  compétition olympique organisée en Afrique édition des JOJ à inclure la participation d’une équipe olympique de jeunes réfugiés édition des JOJ à atteindre la parité des genres en quotas d’athlètes, disciplines et événements  50  73 épreuves masculines 73 épreuves féminines 7 épreuves mixtes  plus de  %  5 000  2 700 200 plus de  d’athlètes masculins et féminins  volontaires  Comités Nationaux Olympiques  athlètes  Parité des genres en boxe, gymnastique et lutte pour la première fois lors de Jeux Olympiques  4  épreuves à médaille  Dakar 2026 Learning Academy  sports font leurs débuts au programme olympique Baseball5 Lutte de plage Aviron de mer Wushu  263  Programme d’éducation du Brevet olympique, civique et sportif  élèves  29  nationalités  900 000 jeunes concernés  11 000 écoles  3  villes hôtes Dakar, Diamniadio, Saly  8  sites de compétition  1  village olympique de la jeunesse"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n\n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'addContentLinkThree'\n        })\n      }\n\n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n\n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n\n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function animateNumbers(klass, delay = 1, stagger = 0.3) {\n        numbers = cOf(klass)\n\n        setTimeout(function() {\n          for (let i = 0; i < numbers.length; i++) {\n            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])\n          }\n        }, delay * 1000)\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.png', '8-gal-2.png'], index])\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-BJRSM4CPQ1" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OLkq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fbGF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l+EB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lsaJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJNA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.95c05bb90c642f130587.js